var tfx_shop_settings = {
  "shop_id": 33968,
  "shop": "billionair-gao.myshopify.com",
  "plan": "partner_test",
  "tfx_plan": {
      "optin": false,
      "popular": false,
      "price": 29.99,
      "extraPixelPrice": 19,
      "shopifyPrices": {
          "Development": 10.99,
          "BasicShopify": 29.99,
          "Shopify": 59.99,
          "AdvancedShopify": 99.99,
          "ShopifyPlus": 199.99
      },
      "isPlanAvailable": true,
      "ui": {
          "color": "#3b4f66",
          "border": "#3f3f3f",
          "width": "auto"
      },
      "limits": {
          "pixels": 8,
          "Server-Side API": "Purchase events",
          "Non-Purchase events Server-Side API": "",
          "Niche Tracking Tags": "Unlimited",
          "analytics": "4 Months",
          "Auto Catalog Feed": "",
          "Custom Diagnosis": "",
          "Scripts & Coding": "Custom",
          "Feed Options": "Enterprise",
          "FB Audience Builder": "Advanced",
          "Large Feed Support": "",
          "Dedicated CS Manager": "",
          "Biweekly Manual Pixel Audit": "",
          "Pixel Audit Recommendations": "",
          "Time Based Events": "Advanced",
          "Report Variants": "",
          "Advanced Matching": "",
          "Report Microdata": "",
          "Value Reporting": "",
          "Price Value Reporting": "",
          "InitiateCheckout Button Click": "",
          "CCPA": "",
          "Tracking Consent Api": "",
          "Event To Fire": "",
          "Enable IOS14 Suppression": "",
          "Enable SS for pending status": ""
      }
  },
  "tfx_planName": "shopifyExtended",
  "currency": "CNY",
  "debug": false,
  "baseURL": "https://trackifyx.redretarget.com",
  "pixels": [{
      "id": 132330,
      "pixel_id": "732959004495841",
      "type": "master",
      "context": [""],
      "enabled": true,
      "month_ago": "2022-08-12T15:41:52Z",
      "serversideapi_enabled": false,
      "serversideapi_status": "",
      "is_token_valid": true
  }],
  "orders": [],
  "logging": true,
  "proxy": "a/tfx",
  "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/103.0.0.0 Safari/537.36",
  "user_ip": "115.193.37.31",
  "id": 42086,
  "enabled": true,
  "report_variants": false,
  "advance_matching": true,
  "microdata": true,
  "value_reporting": true,
  "reporting_percentage": 100,
  "time_on_site": false,
  "ccpa": "",
  "tracking_consent_api": "ignore",
  "event_to_fire": ["pageViewEvent", "viewContentEvent", "viewCategoryEvent", "purchaseEvent", "initiateCheckoutEvent", "addToCartEvent", "microData", "buttonClick"],
  "all_events_for_suppress": ["viewCategoryEvent", "customizeProductEvent", "viewCartEvent", "paymentLeadEvent", "addShippingInfoEvent", "addToWishListEvent", "searchEvent", "contactEvent", "timerEvent", "pageViewEvent", "viewContentEvent", "addPaymentInfoEvent", "purchaseEvent", "initiateCheckoutEvent", "addToCartEvent", "microData", "buttonClick"],
  "enable_ios14_suppression": false,
  "enable_ssevents_for_pending": false,
  "orders_purchase": false,
  "ocu_ss_api": 0,
  "shopify_pixel": false,
  "contents": true,
  "atc_click": true,
  "ic_switch": true
};
function tfx_utm_medium () {
    const search = decodeURIComponent(location.search).replaceAll('?', '');
    const utm_medium = search.split('&').find((t) => t.indexOf('utm_medium') > -1)?.replace('utm_medium=', '');
    const page_extra = JSON.parse($.cookie('as_aws_page_extra') || '{}');
    if (utm_medium && utm_medium != 'fbads_women') return false;
    if (utm_medium === 'fbads_women') return true;
    if (page_extra.utm_medium === 'fbads_women') return true;
    return false;
}
if (tfx_utm_medium()) {
    tfx_shop_settings.pixels.push({
        "id": 132331,
        "pixel_id": "1095203582235202",
        "type": "master",
        "context": [""],
        "enabled": true,
        "month_ago": "2024-07-12",
        "serversideapi_enabled": false,
        "serversideapi_status": "",
        "is_token_valid": true
    });
}
!function(t) {
  var e = {};
  function n(o) {
      if (e[o])
          return e[o].exports;
      var i = e[o] = {
          i: o,
          l: !1,
          exports: {}
      };
      return t[o].call(i.exports, i, i.exports, n),
      i.l = !0,
      i.exports
  }
  n.m = t,
  n.c = e,
  n.d = function(t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: o
      })
  }
  ,
  n.r = function(t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
      }),
      Object.defineProperty(t, "__esModule", {
          value: !0
      })
  }
  ,
  n.t = function(t, e) {
      if (1 & e && (t = n(t)),
      8 & e)
          return t;
      if (4 & e && "object" == typeof t && t && t.__esModule)
          return t;
      var o = Object.create(null);
      if (n.r(o),
      Object.defineProperty(o, "default", {
          enumerable: !0,
          value: t
      }),
      2 & e && "string" != typeof t)
          for (var i in t)
              n.d(o, i, function(e) {
                  return t[e]
              }
              .bind(null, i));
      return o
  }
  ,
  n.n = function(t) {
      var e = t && t.__esModule ? function() {
          return t.default
      }
      : function() {
          return t
      }
      ;
      return n.d(e, "a", e),
      e
  }
  ,
  n.o = function(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e)
  }
  ,
  n.p = "/",
  n(n.s = 4)
}({
  "/SWy": function(t, e, n) {
      "use strict";
      n.r(e);
      var o, i = n("o0o1"), a = n.n(i);
      function r(t) {
          return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
              return typeof t
          }
          : function(t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
          }
          )(t)
      }
      function c(t, e, n, o, i, a, r) {
          try {
              var c = t[a](r)
                , s = c.value
          } catch (t) {
              return void n(t)
          }
          c.done ? e(s) : Promise.resolve(s).then(o, i)
      }
      function s(t) {
          return function(t) {
              if (Array.isArray(t)) {
                  for (var e = 0, n = new Array(t.length); e < t.length; e++)
                      n[e] = t[e];
                  return n
              }
          }(t) || function(t) {
              if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))
                  return Array.from(t)
          }(t) || function() {
              throw new TypeError("Invalid attempt to spread non-iterable instance")
          }()
      }
      function u(t, e) {
          for (var n = 0; n < e.length; n++) {
              var o = e[n];
              o.enumerable = o.enumerable || !1,
              o.configurable = !0,
              "value"in o && (o.writable = !0),
              Object.defineProperty(t, o.key, o)
          }
      }
      function l(t, e) {
          var n = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(t);
              e && (o = o.filter(function(e) {
                  return Object.getOwnPropertyDescriptor(t, e).enumerable
              })),
              n.push.apply(n, o)
          }
          return n
      }
      function d(t) {
          for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? l(n, !0).forEach(function(e) {
                  h(t, e, n[e])
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(n).forEach(function(e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e))
              })
          }
          return t
      }
      function h(t, e, n) {
          return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
          }) : t[e] = n,
          t
      }
      var p = 150
        , g = "PageView"
        , f = "ViewContent"
        , v = "AddToCart"
        , m = "Purchase"
        , y = "InitiateCheckout"
        , _ = "TrackifyXRetarget"
        , w = "Products"
        , k = "Orders"
        , C = "Collections"
        , E = "ThankYou"
        , b = "Search"
        , S = "ZipifyPage"
        , T = "GemProductPage"
        , P = "BetterCartCheckoutThankYou"
        , L = (h(o = {
          AF: "afghanistan",
          AL: "albania",
          DZ: "algeria",
          AS: "americansamoa",
          AD: "andorra",
          AO: "angola",
          AI: "anguilla",
          AQ: "antarctica",
          AG: "antiguaandbarbuda",
          AR: "argentina",
          AM: "armenia",
          AW: "aruba",
          AU: "australia",
          AT: "austria",
          AZ: "azerbaijan",
          BS: "bahamas",
          BH: "bahrain",
          BD: "bangladesh",
          BB: "barbados",
          BY: "belaruz",
          BE: "belgium",
          BZ: "belize",
          BJ: "benin",
          BM: "bermuda",
          BT: "bhutan",
          BO: "bolivia",
          BA: "bosniaandherzegovina",
          BW: "botswana",
          BV: "bouvetisland",
          BR: "brazil",
          BN: "brunei",
          BG: "bulgaria",
          BF: "burkinafaso",
          BI: "burundi",
          KH: "cambodia",
          CM: "cameroon",
          CA: "canada",
          CV: "capeVerde",
          KY: "caymanislands",
          CF: "centralafricanrepublic",
          TD: "chad",
          CL: "chile",
          CN: "china",
          CX: "christmasisland",
          CC: "cocos",
          CO: "colombia",
          KM: "comoros",
          CG: "congo",
          CK: "cookislands",
          CR: "costarica",
          CI: "cotedivoire",
          HR: "croatia",
          CU: "cuba",
          CY: "cyprus",
          CZ: "czechrepublic",
          CS: "czechoslavakia",
          DK: "denmark",
          DJ: "djibouti",
          DM: "dominica",
          DO: "dominicanrepublic",
          TP: "easttimor",
          EC: "ecuador",
          EG: "egypt",
          SV: "elsalvador",
          GQ: "equatorialguinea",
          ER: "eritrea",
          EE: "estonia",
          ET: "ethiopia",
          FK: "falklandislands",
          FO: "faroeislands",
          FJ: "fiji",
          FI: "finland",
          FR: "france",
          GF: "frenchguiana"
      }, "GF", "frenchguyana"),
      h(o, "PF", "frencpolynesia"),
      h(o, "GA", "gabon"),
      h(o, "GM", "gambia"),
      h(o, "GE", "georgia"),
      h(o, "DE", "germany"),
      h(o, "GH", "ghana"),
      h(o, "GI", "gibraltar"),
      h(o, "GB", "greatbritain"),
      h(o, "GB", "unitedkingdom"),
      h(o, "GR", "greece"),
      h(o, "GL", "greenland"),
      h(o, "GD", "grenada"),
      h(o, "GP", "guadeloupe"),
      h(o, "GU", "guam"),
      h(o, "GT", "guatemala"),
      h(o, "GN", "guinea"),
      h(o, "GW", "guinea-bissau"),
      h(o, "GY", "guyana"),
      h(o, "HT", "haiti"),
      h(o, "HM", "heardislandandmcdonaldislands"),
      h(o, "VA", "holysee"),
      h(o, "VA", "vaticancity"),
      h(o, "HN", "honduras"),
      h(o, "HK", "hongKong"),
      h(o, "HU", "hungary"),
      h(o, "IS", "iceland"),
      h(o, "IN", "india"),
      h(o, "ID", "indonesia"),
      h(o, "IR", "iran"),
      h(o, "IR", "islamicrepublicOfiran"),
      h(o, "IQ", "iraq"),
      h(o, "IE", "ireland"),
      h(o, "IL", "israel"),
      h(o, "IT", "italy"),
      h(o, "JM", "jamaica"),
      h(o, "JP", "japan"),
      h(o, "JO", "jordan"),
      h(o, "KZ", "kazakstan"),
      h(o, "KZ", "kazakhstan"),
      h(o, "KE", "kenya"),
      h(o, "KI", "kiribati"),
      h(o, "KP", "northkorea"),
      h(o, "KR", "southkorea"),
      h(o, "KW", "kuwait"),
      h(o, "KG", "kyrgyzstan"),
      h(o, "LA", "laos"),
      h(o, "LV", "latvia"),
      h(o, "LB", "lebanon"),
      h(o, "LS", "lesotho"),
      h(o, "LR", "liberia"),
      h(o, "LY", "libya"),
      h(o, "LI", "liechtenstein"),
      h(o, "LT", "lithuania"),
      h(o, "LU", "luxembourg"),
      h(o, "MO", "macau"),
      h(o, "MK", "macedonia"),
      h(o, "MG", "madagascar"),
      h(o, "MW", "malawi"),
      h(o, "MY", "malaysia"),
      h(o, "MV", "maldives"),
      h(o, "ML", "mali"),
      h(o, "MT", "malta"),
      h(o, "MH", "marshallislands"),
      h(o, "MQ", "martinique"),
      h(o, "MR", "mauritania"),
      h(o, "MU", "mauritius"),
      h(o, "YT", "mayotte"),
      h(o, "MX", "mexico"),
      h(o, "FM", "micronesia"),
      h(o, "MD", "moldova"),
      h(o, "MC", "monaco"),
      h(o, "MN", "mongolia"),
      h(o, "MS", "montserrat"),
      h(o, "MA", "morocco"),
      h(o, "MZ", "mozambique"),
      h(o, "MM", "myanmar"),
      h(o, "NA", "namibia"),
      h(o, "NR", "nauru"),
      h(o, "NP", "nepal"),
      h(o, "NL", "netherlands"),
      h(o, "AN", "netherlandsantilles"),
      h(o, "NC", "newcaledonia"),
      h(o, "NZ", "newzealand"),
      h(o, "NI", "nicaragua"),
      h(o, "NE", "niger"),
      h(o, "NG", "nigeria"),
      h(o, "NU", "niue"),
      h(o, "NF", "norfolkisland"),
      h(o, "MP", "northernmarianaislands"),
      h(o, "NO", "norway"),
      h(o, "OM", "oman"),
      h(o, "PK", "pakistan"),
      h(o, "PW", "palau"),
      h(o, "PS", "palestinianstate"),
      h(o, "PA", "panama"),
      h(o, "PG", "papuanewguinea"),
      h(o, "PY", "paraguay"),
      h(o, "PE", "peru"),
      h(o, "PH", "philippines"),
      h(o, "PN", "pitcairnisland"),
      h(o, "PL", "poland"),
      h(o, "PT", "portugal"),
      h(o, "PR", "puertorico"),
      h(o, "QA", "qatar"),
      h(o, "RO", "romania"),
      h(o, "RU", "russianfederation"),
      h(o, "RW", "rwanda"),
      h(o, "SH", "sainthelena"),
      h(o, "KN", "saintKittsandnevis"),
      h(o, "LC", "saintlucia"),
      h(o, "PM", "saintpierreandmiquelon"),
      h(o, "VC", "saintvincentandthegrenadines"),
      h(o, "WS", "samoa"),
      h(o, "SM", "sanmarino"),
      h(o, "ST", "saotomeandtrincipe"),
      h(o, "SA", "saudiarabia"),
      h(o, "RS", "serbia"),
      h(o, "SN", "senegal"),
      h(o, "SC", "seychelles"),
      h(o, "SL", "sierraleone"),
      h(o, "SG", "singapore"),
      h(o, "SK", "slovakia"),
      h(o, "SI", "slovenia"),
      h(o, "SB", "solomon"),
      h(o, "SO", "somalia"),
      h(o, "ZA", "southafrica"),
      h(o, "GS", "southgeorgiaandthesouthsandwichislands"),
      h(o, "ES", "spain"),
      h(o, "LK", "sriLanka"),
      h(o, "SD", "sudan"),
      h(o, "SR", "suriname"),
      h(o, "SJ", "svalbard"),
      h(o, "SZ", "swaziland"),
      h(o, "SE", "sweden"),
      h(o, "CH", "switzerland"),
      h(o, "SY", "syria"),
      h(o, "TW", "taiwan"),
      h(o, "TJ", "tajikistan"),
      h(o, "TZ", "tanzania"),
      h(o, "TH", "thailand"),
      h(o, "TG", "togo"),
      h(o, "TK", "tokelau"),
      h(o, "TO", "tonga"),
      h(o, "TT", "trinidadandtobago"),
      h(o, "TE", "tromelinisland"),
      h(o, "TN", "tunisia"),
      h(o, "TR", "turkey"),
      h(o, "TM", "turkmenistan"),
      h(o, "TC", "turksandcaicosislands"),
      h(o, "TV", "tuvalu"),
      h(o, "UG", "uganda"),
      h(o, "UA", "ukraine"),
      h(o, "AE", "unitedarabemirates"),
      h(o, "US", "unitedstates"),
      h(o, "UY", "uruguay"),
      h(o, "UZ", "uzbekistan"),
      h(o, "VU", "vanuatu"),
      h(o, "VA", "vaticancitystate"),
      h(o, "VE", "venezuela"),
      h(o, "VN", "vietnam"),
      h(o, "VI", "virginislandsbritish"),
      h(o, "VQ", "virginislandsunitedstates"),
      h(o, "WF", "wallisandfutunaislands"),
      h(o, "EH", "westernsahara"),
      h(o, "YE", "yemen"),
      h(o, "YU", "yugoslavia"),
      h(o, "ZR", "zaire"),
      h(o, "ZM", "zambia"),
      h(o, "ZW", "zimbabwe"),
      o);
      function O(t) {
          var e = null;
          return window.location.href.indexOf(t) > -1 && window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(t, n, o) {
              e = o
          }),
          e
      }
      function I(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          (n = d({
              path: "/",
              SameSite: "Strict"
          }, n)).expires && n.expires.toUTCString && (n.expires = n.expires.toUTCString());
          var o = encodeURIComponent(t) + "=" + encodeURIComponent(e);
          for (var i in n) {
              o += "; " + i;
              var a = n[i];
              !0 !== a && (o += "=" + a)
          }
          document.cookie = o
      }
      function F(t) {
          var e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
          return e ? decodeURIComponent(e[1]) : null
      }
      function A(t) {
          I(t, "", {
              "max-age": -1
          })
      }
      function x(t, e) {
          for (var n = e.split("."), o = 0, i = n.length; o < i; o++) {
              if (!t || !t[n[o]])
                  return !1;
              t = t[n[o]]
          }
          return !0
      }
      function U(t, e) {
          for (var n = e.split("."), o = 0, i = n.length; o < i; o++) {
              if (!t || !t[n[o]])
                  return null;
              t = t[n[o]]
          }
          return t
      }
      function N(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return new Promise(function(n, o) {
              var i = new XMLHttpRequest;
              i.open(e.method || "GET", t),
              e.headers && Object.keys(e.headers).forEach(function(t) {
                  i.setRequestHeader(t, e.headers[t])
              }),
              i.onload = function() {
                  i.status >= 200 && i.status < 300 ? n(i.response) : o(i.statusText)
              }
              ,
              i.onerror = function() {
                  return o(i.statusText)
              }
              ,
              i.send(e.body)
          }
          )
      }
      function NN(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          var data = JSON.parse(e.body);
          if ([f, v, y, m].indexOf(data.ev) < 0) {
              return new Promise(function(resolve, reject){
                  resolve(null);
              })
          }
          let PIXELDATA =  localStorage.getItem('PIXELDATA');
          if(PIXELDATA) PIXELDATA = JSON.parse(PIXELDATA);

          let { am, us, ev, ssed, px } = data;
          let params = {
              event_name: data.ev,
              event_id: data.evId,
              event_source_url: data.url,
              event_time: parseInt(new Date(data.ts).getTime()/1000).toString(),
              // event_time: ssed.content_timedata,
              shopId: theme.shopId,
              external_id: F('_shopify_y') || us.external_id || am.external_id,
              client_ip_address: data.uip,
              client_user_agent: navigator.userAgent || window.ua,
              country: (us.country&&us.country.toLowerCase()) || (am&&am.country&&am.country.toLowerCase()),
              fbc: us.fbc || (am&&am.fbc) || F("as_fbc"),
              fbp: us.fbp || (am&&am.fbp) || F("as_fbp"),
              em: us.em || (am&&am.em) || (PIXELDATA? PIXELDATA.em: ''),
              ph: us.ph || (am&&am.ph) || (PIXELDATA? PIXELDATA.ph: ''),     
              fn: us.fn || (am&&am.fn) || (PIXELDATA? PIXELDATA.fn: ''),     
              ln: us.ln || (am&&am.ln) || (PIXELDATA? PIXELDATA.ln: ''),     
              ct: us.ct || (am&&am.ct) || (PIXELDATA? PIXELDATA.ct: ''),     
              zp: us.zp || (am&&am.zp) || (PIXELDATA? PIXELDATA.zp: ''),     
              st: us.st || (am&&am.st) || (PIXELDATA? PIXELDATA.st: '')
          };
          let num_items = ssed.contents.reduce((a, b)=>{
              return a + b.quantity * 1;
          } ,0);
          params.content_type = ssed.content_type;
          params.content_ids = Array.isArray(ssed.content_ids) ? ssed.content_ids: [ssed.content_ids];
          params.content_name = ssed.content_name;
          params.currency = ssed.currency;
          params.value = ssed.value;
          params.num_items = num_items || ssed.num_items || 1;
          params.content_category = ssed.content_category;
          params.contents = ssed.contents;
          params.landingPageUrl =  F('as_aws_landing_page') || '';
          params.multi_pixel = px.join();
          if(ev === m){
              params.order_id = Number(data.evId);
          }
          return new Promise(function(resolve, reject){
              fetch(t, {
                  method: 'POST',
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify(params),                    
              }).then(res => res.json()).then(res =>{
                  resolve(res);
              }).catch(e => reject(e));
          })
      }
      function D() {
          var t = (new Date).toLocaleString("en-US", {
              timeZone: "America/New_York"
          })
            , e = new Date(t)
            , n = e.toDateString().split(" ")
            , o = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][e.getDay()];
          return n[1] + "_" + e.getDate() + "_" + e.getFullYear() + "_" + o + "_Hour_" + e.getHours()
      }
      function q(t) {
          return "string" != typeof t ? "" : t.charAt(0).toUpperCase() + t.slice(1)
      }
      function R(t, e, n) {
          e.split(" ").forEach(function(e) {
              return t.addEventListener(e, n, !1)
          })
      }
      function j() {
          var t, e = {
              options: [],
              header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
              dataos: [{
                  name: "Windows Phone",
                  value: "Windows Phone",
                  version: "OS"
              }, {
                  name: "Windows",
                  value: "Win",
                  version: "NT"
              }, {
                  name: "iPhone",
                  value: "iPhone",
                  version: "OS"
              }, {
                  name: "iPad",
                  value: "iPad",
                  version: "OS"
              }, {
                  name: "Kindle",
                  value: "Silk",
                  version: "Silk"
              }, {
                  name: "Android",
                  value: "Android",
                  version: "Android"
              }, {
                  name: "PlayBook",
                  value: "PlayBook",
                  version: "OS"
              }, {
                  name: "BlackBerry",
                  value: "BlackBerry",
                  version: "/"
              }, {
                  name: "Macintosh",
                  value: "Mac",
                  version: "OS X"
              }, {
                  name: "Linux",
                  value: "Linux",
                  version: "rv"
              }, {
                  name: "Palm",
                  value: "Palm",
                  version: "PalmOS"
              }],
              databrowser: [{
                  name: "Chrome",
                  value: "Chrome",
                  version: "Chrome"
              }, {
                  name: "Firefox",
                  value: "Firefox",
                  version: "Firefox"
              }, {
                  name: "Safari",
                  value: "Safari",
                  version: "Version"
              }, {
                  name: "Internet Explorer",
                  value: "MSIE",
                  version: "MSIE"
              }, {
                  name: "Opera",
                  value: "Opera",
                  version: "Opera"
              }, {
                  name: "BlackBerry",
                  value: "CLDC",
                  version: "CLDC"
              }, {
                  name: "Mozilla",
                  value: "Mozilla",
                  version: "Mozilla"
              }],
              init: function() {
                  var t = this.header.join(" ");
                  return {
                      os: this.matchItem(t, this.dataos),
                      browser: this.matchItem(t, this.databrowser)
                  }
              },
              matchItem: function(t, e) {
                  var n, o, i, a = 0, r = 0;
                  for (a = 0; a < e.length; a += 1)
                      if (new RegExp(e[a].value,"i").test(t)) {
                          if (n = new RegExp(e[a].version + "[- /:;]([\\d._]+)","i"),
                          i = "",
                          (o = t.match(n)) && o[1] && (o = o[1]),
                          o)
                              for (o = o.split(/[._]+/),
                              r = 0; r < o.length; r += 1)
                                  i += 0 === r ? o[r] + "." : o[r];
                          else
                              i = "0";
                          return {
                              name: e[a].name,
                              version: parseFloat(i)
                          }
                      }
                  return {
                      name: "unknown",
                      version: 0
                  }
              }
          }.init();
          return {
              osName: e.os ? e.os.name : "unknown",
              osVersion: e.os ? e.os.version : "unknown",
              browserName: e.browser ? e.browser.name : "unknown",
              browserVersion: e.browser ? e.browser.version : "unknown",
              navigatorUserAgent: navigator.version || "unknown",
              isMobile: (t = navigator.userAgent || navigator.vendor || window.opera,
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4)) ? 1 : 0)
          }
      }
      function M(t, e, n) {
          document.querySelector(t) || e <= 0 ? n(document.querySelector(t)) : window.setTimeout(function() {
              M(t, --e, n)
          }, 250)
      }
      function B(t, e, n) {
          document.querySelectorAll(t) || e <= 0 ? n(document.querySelectorAll(t)) : window.setTimeout(function() {
              B(t, --e, n)
          }, 250)
      }
      var X = function() {
          function t() {
              !function(t, e) {
                  if (!(t instanceof e))
                      throw new TypeError("Cannot call a class as a function")
              }(this, t),
              // this.backendURL = "https://trackifyx.redretarget.com",
              // this.backendURL = "https://sw.ahaselected.com",
              // this.backendURL = window.Shopify.theme && window.Shopify.theme.role === "development" ? 'https://test1.ahaselected.com' : "https://sw.ahaselected.com",
              this.backendURL = window.location.host.includes('.ahaselected.') ? "https://sw.ahaselected.com" : 'https://test1.ahaselected.com',
              this.uniqueId = "_" + Math.random().toString(36).substr(2, 9),
              this.shopName = null,
              this.shopHost = "",
              this.shop = null,
              this.isZipifyTagsCollectionsLoaded = !1,
              this.isLogingZipifyTagsCollections = !1,
              this.zipifyProductsTagsCollections = [],
              this.collections = [],
              this.tags = [],
              this.pixels = [],
              this.initializedPixels = [],
              this.page = null,
              this.product = null,
              this.cart = null,
              this.checkout = null,
              this.isTriggeredByState = !1,
              this.isLoadingProduct = !1,
              this.isAddingToCart = !1,
              this.isFetchingShop = !1,
              this.isFetchingCart = !1,
              this.user = this.saveEmptyUser(),
              this.maxAttemps = p,
              this.debug = !0,
              this.eventPrefix = "",
              this.timeOnPage = 0,
              this.reloadCartAttemps = 5,
              this.timeOnSite = parseInt(localStorage.getItem("TFX_TIME_ON_SITE") || 0),
              this.isLoaded = !1,
              this.productIds = [],
              this.pixelEvent = !0,
              this.advanceMatching = !0,
              this.isIOS14 = !1,
              this.viewCategoryEventFire = !0,
              this.viewContentEventFire = !0,
              this.viewCartEventFire = !0,
              this.pageViewEventFire = !0,
              this.customizeProductEventFire = !0,
              this.addToCartEventFire = !0,
              this.initiateCheckoutEventFire = !0,
              this.addPaymentLeadEventFire = !0,
              this.addShippingInfoEventFire = !0,
              this.addPaymentInfoEventFire = !0,
              this.purchaseEventFire = !0,
              this.addToWishlistEventFire = !0,
              this.searchEventFire = !0,
              this.contactEventFire = !0,
              this.timerEventFire = !0,
              this.isScriptInIframe = window.self !== window.top,
              this.upsellInCartOnce = !0,
              this.incartForms = 0,
              this.isBetterCart = !1,
              this.isPageFlyPage = !1,
              this.isShogunPage = !1,
              this.interCartEvents = [],
              this.interCartEvent = null,
              this.triggerQueue(),
              this.triggerATCQueue(),
              this.iscategoryswatchloaded = 0,
              this.client_ip_address = {},
              this.is_client_ip_address_loaded = !1,
              this.loadtimes = 10
          }
          var e, n, o;
          return e = t,
          (n = [{
              key: "reset",
              value: function() {
                  this.tags = [],
                  this.collections = [],
                  this.page = null,
                  this.product = null,
                  this.maxAttemps = p
              }
          }, {
              key: "init",
              value: function() {
                  var t = this
                    , e = window.location.href;
                  e = e.replace("https://", ""),
                  // !this.is_client_ip_address_loaded && (e.includes("/products/") || e.includes("/cart") || e.includes("/thank_you") || e.includes("/checkouts/")) && (this.is_client_ip_address_loaded = !0,
                  // this.getipInfo()),
                  !this.is_client_ip_address_loaded && (this.is_client_ip_address_loaded = !0, this.getipInfo()),
                  this.isResourcesLoaded() ? this.shop.enabled ? (this.loadIOSDeviceVersions(),
                  this.setup()) : this.consoleLog("This shop is disabled") : (this.maxAttemps === p && this.load(),
                  setTimeout(function() {
                      if (--t.maxAttemps <= 0) {
                          var e = t.getFailMessage();
                          t.consoleLog(e),
                          t.consoleLog(t)
                      } else
                          t.load(),
                          t.loadIOSDeviceVersions(),
                          t.init()
                  }, 30))
              }
          }, {
              key: "getipInfo",
              value: function() {
                  var t = this
                    , e = this;
                    t.client_ip_address = JSON.parse(F("as_shopify_ip_address") || '{}');
                //   N("https://pro.ip-api.com/json?key=oCEsd4fbwMPO07m").then(function(e) {
                //       t.client_ip_address = JSON.parse(e)
                //   }).catch(function(t) {
                //       e.consoleLog("TFX", t)
                //   })
              }
          }, {
              key: "initTrackingConsent",
              value: function() {
                  var t = this;
                  if (t.consoleLog("init tracking function is called"),
                  U(window, "Shopify.loadFeatures"))
                      t.consoleLog("Shopify.loadFeatures property loaded");
                    //   window.Shopify.loadFeatures([{
                    //       name: "consent-tracking-api",
                    //       version: "0.1"
                    //   }], function(e) {
                    //       if (e)
                    //           throw t.consoleLog(e, "Shopify.loadFeatures property error"),
                    //           e;
                    //       t.initCookieBanner()
                    //   });
                  else {
                      if (t.consoleLog("Shopify.loadFeatures property not loaded"),
                      !localStorage.getItem("TFX_CONSENT"))
                          return;
                      t.consoleLog("TFX Consent available");
                      var e = JSON.parse(localStorage.getItem("TFX_CONSENT"))
                        , n = e.userCanBeTracked
                        , o = e.userTrackingConsent;
                      if (t.consoleLog(' tracking consent response : User Can Be Tracked "'.concat(n, '"')),
                      t.consoleLog(' tracking consent response : Get Tracking consent "'.concat(o, '"')),
                      !n && "no_interaction" === o || "no" === o)
                          switch (this.shop.tracking_consent_api) {
                          case "all":
                              this.pixelEvent = !1,
                              t.consoleLog("Pixel Is blocked because tracking consent is not given");
                              break;
                          case "advance":
                              t.consoleLog("Advance Matching Is blocked because tracking consent is not given"),
                              this.advanceMatching = !1
                          }
                  }
              }
          }, {
              key: "initCookieBanner",
              value: function() {
                  var t = window.Shopify.customerPrivacy.userCanBeTracked();
                  this.consoleLog("Cookie Banner Function is called");
                  var e = window.Shopify.customerPrivacy.getTrackingConsent();
                  this.consoleLog(' tracking consent response : User Can Be Tracked "'.concat(t, '"')),
                  this.consoleLog(' tracking consent response : Get Tracking consent "'.concat(e, '"'));
                  var n = {
                      userCanBeTracked: t,
                      userTrackingConsent: e
                  };
                  if (this.setConsent(n),
                  !t && "no_interaction" === e || "no" === e)
                      switch (this.shop.tracking_consent_api) {
                      case "all":
                          this.pixelEvent = !1,
                          this.consoleLog("Pixel Is blocked because tracking consent is not given");
                          break;
                      case "advance":
                          this.consoleLog("Advance Matching Is blocked because tracking consent is not given"),
                          this.advanceMatching = !1
                      }
                  return !0
              }
          }, {
              key: "setConsent",
              value: function(t) {
                  t && localStorage.setItem("TFX_CONSENT", JSON.stringify(t))
              }
          }, {
              key: "load",
              value: function() {
                  this.setUTMs(),
                  this.user || this.getUserExternalId(),
                  this.page || this.setPage(),
                  this.shopName || this.setShopName(),
                  "fbq"in window || this.loadPixelLibrary(),
                  !this.shop && this.shopName && this.loadShopSettings(),
                  this.shop && !this.product && this.loadProduct(),
                  this.tags.length || this.loadTags(),
                  this.collections.length || this.loadCollections(),
                  this.cart || this.loadCart(),
                  -1 === [E, k, P].indexOf(this.page) || this.checkout || this.loadCheckout(),
                  this.isTriggeredByState && this.page === w && this.setTagsCollections(window.location.pathname),
                  this.page !== S || this.isZipifyTagsCollectionsLoaded || this.setZipifyTagsCollections(),
                  "UpSellPage" === this.page && this.getOCUProduct()
              }
          }, {
              key: "loadIOSDeviceVersions",
              value: function() {}
          }, {
              key: "getFailMessage",
              value: function() {
                  var t = [];
                  switch ("fbq"in window || t.push("FB Pixel script is not loaded"),
                  this.shop || t.push("Can not get shop info"),
                  this.shopName || t.push("Can not get shop name"),
                  this.page || t.push("Can not get page"),
                  this.page) {
                  case T:
                      this.product || t.push("Can not get product for GEM_PRODUCTS_PAGE."),
                      this.page = g,
                      this.init();
                      break;
                  case "PageFly":
                  case "Shogun":
                  case w:
                      this.product || t.push("Can not get product checking zipify pages"),
                      x(window, "ZipifyPages") && (this.page = S,
                      this.init());
                      break;
                  case "Cart":
                      this.cart || t.push("Can not get cart");
                      break;
                  case E:
                      this.checkout || t.push("Can not get checkout")
                  }
                  return t.join("\n* ")
              }
          }, {
              key: "isResourcesLoaded",
              value: function() {
                  var t = "fbq"in window && this.shopName && this.shop && this.page
                    , e = !0;
                  switch (this.page) {
                  case T:
                  case w:
                      e = this.product;
                      break;
                  case "PageFly":
                      window.__pageflyProducts && (e = this.product && this.collections);
                      break;
                  case "Shogun":
                      window.__shgProducts && window.__shgProducts.length && (e = this.product && this.collections);
                      break;
                  case "Cart":
                      e = this.cart;
                      break;
                  case E:
                      e = this.checkout
                  }
                  return t && e
              }
          }, {
              key: "setup",
              value: function() {
                  if (this.isLoaded)
                      this.consoleLog("TFX already loaded");
                  else {
                      this.setDebugMode(),
                      this.consoleLog("setup function is called"),
                      this.consoleLog("USER", this.user),
                      this.initTrackingConsent();
                      var t = this;
                      setTimeout(function() {
                          t.consoleLog("TFX ID: " + t.uniqueId),
                          t.isLoaded = !0,
                          t.setEventsPrefix(),
                          t.consoleLog("Loaded", t),
                          t.shop && t.consoleLog(window),
                          t.consoleLog(' Page is "'.concat(t.page, '"')),
                          t.filterPixels() && t.pixelEvent ? (t.initPixels(),
                          t.fireEvents(),
                          t.isEventsAttached || t.attachListeners(),
                          t.shop.time_on_site && t.trackTime()) : t.consoleLog("No Attached Pixels to current scenario")
                      }, 500)
                  }
              }
          }, {
              key: "setEventsPrefix",
              value: function() {
                  x(window, "OCUConfig") && (this.eventPrefix = "OCU")
              }
          }, {
              key: "setDebugMode",
              value: function() {
                  this.debug = this.shop.debug
              }
          }, {
              key: "consoleLog",
              value: function() {
                  if (this && this.debug) {
                      var t = [];
                      t.push("TFX:");
                      for (var e = 0; e < arguments.length; e++)
                          t.push(arguments[e]);
                  }
              }
          }, {
              key: "setPage",
              value: function() {
                  var t = this
                    , e = window.location.href
                    , n = this;
                  if ((e = e.replace("https://", "")).includes("/collections") && (this.page = C),
                  e.includes("/products/") && (this.page = w),
                  e.includes("/cart"))
                      this.page = "Cart";
                  else {
                      if ((e.includes("/checkouts/") || e.includes("/secure-checkout/") && U(window, "OCUConfig")) && (this.page = "Checkout"),
                      e.includes("/s/checkout/") && (this.page = "Checkout"),
                      (e.includes("/secure-checkout/offers/") || e.includes("/secure-chechout/offers")) && (this.page = "UpSellPage"),
                      e.includes("/thank_you") && (this.page = E),
                      e.includes("/orders/") && (this.page = k),
                      e.includes("/secure-checkout/thank_you/") && (this.page = "OCUThankYou"),
                      e.includes("/account/login") && (this.page = "Login"),
                      e.includes("/account/register") && (this.page = "SignUp"),
                      e.includes("/search") && (this.page = b),
                      e.includes("apps/fast-checkout/")) {
                          e.includes("checkouts") && (this.page = "BetterCartCheckout");
                          var o = location.href;
                          setInterval(function() {
                              if (o != location.href) {
                                  o = location.href;
                                  var e = window.location.href;
                                  "payment" != O("step") || F("TFX_BC_PI") || (t.addPaymentInfoEvent(),
                                  I("TFX_BC_PI", !0, {
                                      "max-age": 60
                                  })),
                                  (e.includes("fast-checkout/checkouts") && e.includes("order") || e.includes("fast-checkout/orders") && e.includes("thank-you")) && !window.location.hash && (window.location = window.location + "#loaded",
                                  e.includes("fast-checkout/orders") && e.includes("thank-you") && (n.isLoaded = !1,
                                  n.checkout = null,
                                  n.cart = null),
                                  n.reset(),
                                  setTimeout(function() {
                                      n.load(),
                                      n.attachListeners(),
                                      n.filterPixels(),
                                      n.initPixels()
                                  }, 500))
                              }
                          }, 1500),
                          setTimeout(function() {
                              n.initiateCheckoutEvent()
                          }, 2e3)
                      }
                      e.includes("fast-checkout/checkouts") && e.includes("order") && (this.page = "BetterCartCheckoutOffer"),
                      e.includes("fast-checkout/orders") && e.includes("thank-you") && (this.page = P),
                      x(window, "ZipifyPages") && !e.includes("/products/") && (this.page = S),
                      "checkout_page" === U(window, "CHDataObject.partial_type") && (this.page = "CartHookCheckout"),
                      "thank_you_page" === U(window, "CHDataObject.partial_type") && (this.page = "CartHookThankYou"),
                      "upsell_page" === U(window, "CHDataObject.partial_type") && (this.page = "CartHookUpSellPage"),
                      "downsell_page" === U(window, "CHDataObject.partial_type") && (this.page = "CartHookDownSellPage"),
                      "page" === U(window, "CHDataObject.partial_type") && (this.page = "CartHookPage"),
                      document.querySelector("body.gempage") && e.includes("/pages/") && (this.page = T),
                      (e.includes("/pages/") || e.includes("/blogs/news/") || e.includes("/password")) && document.querySelector('link[href*="pagefly"]') && (this.page = "PageFly"),
                      (e.includes("/pages/") || e.includes("/blogs/news/") || e.includes("/password")) && document.querySelector('link[href*="shogun"]') && (this.page = "Shogun"),
                      this.page || (this.page = "Unknown")
                  }
              }
          }, {
              key: "loadPixelLibrary",
              value: function() {
                  if ("fbq"in window)
                      return !0;
                  var t, e, n, o, i, a;
                  t = window,
                  e = document,
                  n = "script",
                  t.fbq || (o = t.fbq = function() {
                      o.callMethod ? o.callMethod.apply(o, arguments) : o.queue.push(arguments)
                  }
                  ,
                  t._fbq || (t._fbq = o),
                  o.push = o,
                  o.loaded = !0,
                  o.version = "2.0",
                  o.queue = [],
                  (i = e.createElement(n)).async = !0,
                  i.src = "https://connect.facebook.net/en_US/fbevents.js",
                  (a = e.getElementsByTagName(n)[0]).parentNode.insertBefore(i, a))
              }
          }, {
              key: "loadShopSettings",
              value: function() {
                  var t = this;
                  if ("undefined" != typeof tfx_shop_settings)
                      this.shop = tfx_shop_settings,
                      this.product || this.loadProduct();
                  else {
                      if (t.isFetchingShop)
                          return;
                      t.isFetchingShop = !0,
                      setTimeout(function() {
                          t.isFetchingShop = !1
                      }, 700),
                      t.consoleLog("config route called"),
                      console.log('loadShopSettings');
                      // N("".concat(this.backendURL, "/pull/config/").concat(this.shopName)).then(function(e) {
                      //     t.shop = JSON.parse(e),
                      //     t.isFetchingShop = !1,
                      //     t.product || t.loadProduct()
                      // }).catch(function(e) {
                      //     t.consoleLog("TFX", e)
                      // })
                  }
              }
          }, {
              key: "setShopName",
              value: function() {
                  this.shopName = U(window, "Shopify.shop") || U(window, "Shopify.Checkout.apiHost") || U(window, "CHDataObject.store_urls.store_url"),
                  this.shopName || "undefined" == typeof tfx_shop_settings || (this.shopName = tfx_shop_settings.shop),
                  window.getOrderRequestObject && (this.shopName = window.getOrderRequestObject().shop),
                  "BetterCartCheckout" != this.page && "BetterCartCheckoutOffer" != this.page && this.page != P || (this.shopName = window.location.hostname)
              }
          }, {
              key: "getUserExternalId",
              value: function() {
                  var t = this
                    , e = 5;
                  !function n() {
                      "Shopify"in window ? t.setUser({
                          external_id: F('_shopify_y') ||  null
                      }) : --e >= 0 && setTimeout(function() {
                          t.consoleLog("time out for external ID"),
                          n()
                      }, 200)
                  }()
              }
          }, {
              key: "loadCheckout",
              value: function() {
                  this.checkout = U(window, "Shopify.checkout"),
                  this.checkout || this.page != P || (this.checkout = U(window, "bcData.order"),
                  this.checkout.discount = U(window, "bcData.order.coupon"))
              }
          }, {
              key: "printTags",
              value: function(t) {
                  var e = t || this.tags || (localStorage.getItem("tags") || "").split(", ");
                  return e && e.length ? (t || (this.tags = e),
                  s(new Set(e.map(function(t) {
                      return "string" == typeof t ? t.toString().trim() : t
                  }).filter(function(t) {
                      return "" !== t.trim()
                  }))).join(", ")) : ""
              }
          }, {
              key: "printCollections",
              value: function(t) {
                  var e = t || this.collections || (localStorage.getItem("collections") || "").split(", ");
                  return e && e.length ? (t || (this.collections = e),
                  s(new Set(e.map(function(t) {
                      return "string" == typeof t ? t.toString().trim() : t
                  }).filter(function(t) {
                      return "" !== t.trim()
                  }))).join(", ")) : ""
              }
          }, {
              key: "clearArray",
              value: function(t) {
                  return t && Array.isArray(t) ? t.map(function(t) {
                      return t.trim()
                  }).filter(function(t) {
                      return t.length > 0
                  }) : []
              }
          }, {
              key: "loadTags",
              value: function() {
                  var t = document.querySelector('meta[name="tfx:tags"]');
                  t ? (this.tags = this.clearArray(t.content.split(", ")),
                  localStorage.setItem("tags", this.tags.join(", "))) : -1 === [w, C, T, b, S].indexOf(this.page) && (this.tags = (localStorage.getItem("tags") || "").split(", "),
                  "/pages/kontakt" != window.location.pathname && "/pages/contact" != window.location.pathname && "/account/login" != window.location.pathname && "/pages/faq" != window.location.pathname && "/pages/newsletter" != window.location.pathname && "/pages/jobs" != window.location.pathname && "/pages/presse" != window.location.pathname || (this.tags = []))
              }
          }, {
              key: "loadCollections",
              value: function() {
                  var t = document.querySelector('meta[name="tfx:collections"]');
                  if (t)
                      this.collections = t.content.split(", ").map(function(t) {
                          return t.trim()
                      }).filter(function(t) {
                          return t.length > 0
                      }),
                      localStorage.setItem("collections", this.collections.join(", "));
                  else {
                      var e = localStorage.getItem("collections") || "";
                      this.collections = e.split(", ")
                  }
              }
          }, {
              key: "extractTagsCollections",
              value: function(t) {
                  var e = {
                      tags: [],
                      collections: []
                  }
                    , n = /<meta name="tfx:tags" content="(.*?)">/g.exec(t)
                    , o = /<meta name="tfx:collections" content="(.*?)">/g.exec(t);
                  return n && (e.tags = n[1].split(", ").map(function(t) {
                      return t.trim()
                  }).filter(function(t) {
                      return t.length > 0
                  })),
                  o && (e.collections = o[1].split(", ").map(function(t) {
                      return t.trim()
                  }).filter(function(t) {
                      return t.length > 0
                  })),
                  e
              }
          }, {
              key: "setTagsCollections",
              value: function(t) {
                  var e = this;
                  this.getTagsCollections(t).then(function(t) {
                      var n = e.extractTagsCollections(t);
                      e.tags = n.tags,
                      localStorage.setItem("tags", e.clearArray(e.tags).join(", ")),
                      e.collections = n.collections,
                      localStorage.setItem("collections", e.clearArray(e.collections).join(", "))
                  }).catch(this.consoleLog)
              }
          }, {
              key: "getTagsCollections",
              value: function(t) {
                  return N(t)
              }
          }, {
              key: "setTagsAndCollectionsFromBackend",
              value: function(t) {
                  var e = this
                    , n = this;
                  return t ? new Promise(function(o, i) {
                      console.log("setTagsAndCollectionsFromBackend");
                      // N("".concat(e.backendURL, "/get/").concat(e.shopName, "/products?ids=") + t.join(",")).then(function(t) {
                      //     var a = JSON.parse(t);
                      //     if (a.products && a.products.length) {
                      //         var r = a.products.map(function(t) {
                      //             return new Promise(function(o, i) {
                      //                 e.getTagsCollections("".concat(e.shopHost, "/products/").concat(t.handle)).then(function(i) {
                      //                     var a = e.extractTagsCollections(i);
                      //                     n.collections = n.collections.concat(a.collections),
                      //                     n.tags = n.tags.concat(a.tags),
                      //                     o({
                      //                         product_id: t.id,
                      //                         html: i
                      //                     })
                      //                 }).catch(function(t) {
                      //                     i(t)
                      //                 })
                      //             }
                      //             )
                      //         });
                      //         Promise.all(r).then(function() {
                      //             n.tags = s(new Set(n.tags)),
                      //             n.collections = s(new Set(n.collections)),
                      //             n.filterPixels(),
                      //             n.initPixels(),
                      //             o()
                      //         }).catch(function(t) {
                      //             o(t)
                      //         })
                      //     } else
                      //         i("No products fetched...")
                      // }).catch(i)
                  }
                  ) : new Promise(function(t) {
                      return t()
                  }
                  )
              }
          }, {
              key: "getProduct",
              value: function(t) {
                  if (t)
                      return N(t.endsWith("/") ? t.slice(0, -1) : t + ".json")
              }
          }, {
              key: "getProductById",
              value: function(t) {
                  if (t)
                      return N("".concat(this.backendURL, "/get/").concat(this.shopName, "/products?ids=").concat(t))
              }
          }, {
              key: "loadProduct",
              value: function() {
                  var t = this;
                  if (!this.isLoadingProduct) {
                      var e = window.tfxProduct;
                        t.product = e;
                      // var e = window.tfxProduct || null
                      //   , n = this;
                      // if (n.isLoadingProduct = !0,
                      // setTimeout(function() {
                      //     0 == t.incartForms && (t.incartForms = document.querySelectorAll("form[action='/cart/add'].variants").length,
                      //     n.consoleLog(t.incartForms + " upsell offer"))
                      // }, 1e3),
                      // e)
                      //     this.product = e;
                      // else {
                      //     var o = U(window, "ShopifyAnalytics.meta.page.pageType") ? window.ShopifyAnalytics.meta.page.pageType : "Unknown";
                      //     if (!window.__pageflyProducts || "home" != o && "page" != o && "article" != o && "password" != o || (this.isPageFlyPage = !0),
                      //     "PageFly" === this.page) {
                      //         if (!this.shop)
                      //             return null;
                      //         if (window.__pageflyProducts)
                      //             for (var i in window.__pageflyProducts)
                      //                 window.__pageflyProducts.hasOwnProperty(i) && i && (this.product = d({}, window.__pageflyProducts[i].selected_or_first_available_variant),
                      //                 this.shop.report_variants || (this.product.id = parseInt(i)),
                      //                 this.tags = window.__pageflyProducts[i].tags,
                      //                 this.setTagsCollections("/products/".concat(window.__pageflyProducts[i].handle)))
                      //     } else if (void 0 !== window.__shgProducts && (n.isShogunPage = !0,
                      //     "Shogun" === n.page)) {
                      //         if (!n.shop)
                      //             return null;
                      //         if (window.__shgProducts)
                      //             for (var a in n.consoleLog("Is shogun product page"),
                      //             window.__shgProducts)
                      //                 window.__shgProducts.hasOwnProperty(a) && a && (n.consoleLog("shogun product"),
                      //                 n.consoleLog(window.__shgProducts[a]),
                      //                 n.product = window.__shgProducts[a],
                      //                 n.tags = window.__shgProducts[a].tags,
                      //                 n.setTagsCollections("/products/".concat(window.__shgProducts[a].handle)))
                      //     }
                      //     "Cart" === this.page && null == this.product && this.incartForms > 0 && this.getInCartUpsellProduct(this.upsellInCartOnce);
                      //     var r = document.querySelectorAll("form[action='/cart/add']");
                      //     if (r.length > 0 && this.page != C && !this.isPageFlyPage && !this.isShogunPage) {
                      //         var c = r[0]
                      //           , s = c.querySelector('input[name="id"]')
                      //           , u = c.getAttribute("id");
                      //         n.consoleLog("Product Form detected, product id is ".concat(u)),
                      //         s && s.getAttribute("data-productid") && (u = s.getAttribute("data-productid")),
                      //         u && (u = (u = (u = (u = (u = (u = (u = (u = u.replace("product_form_", "")).replace("upsell_product_form_", "")).replace("product-form-", "")).replace("product-template", "")).replace("AddToCartForm--", "")).replace("AddToCartForm-", "")).replace("js--", "")).replace(/\D/g, ""),
                      //         isNaN(parseInt(u)) && (u = c.getAttribute("data-product_id")),
                      //         n.consoleLog("Cleared Product ID is: ".concat(parseInt(u))),
                      //         parseInt(u) && (parseInt(u) < 1e4 && document.querySelector("[product-id]") && -1 != document.querySelector("[product-id]").getAttribute("class").indexOf("arv-collection") && (u = document.querySelector("[product-id]").getAttribute("product-id"),
                      //         n.consoleLog("more filters with Product ID is: ".concat(parseInt(u)))),
                      //         this.isLoadingProduct = !0,
                      //         this.getProductById(u).then(function(e) {
                      //             var o = JSON.parse(e);
                      //             if (o.products && o.products.length)
                      //                 t.product = o.products[0],
                      //                 t.setTagsCollections("/products/".concat(t.product.handle)),
                      //                 t.page != w && setTimeout(function() {
                      //                     t.viewContentEvent()
                      //                 }, 500);
                      //             else {
                      //                 var i = document.querySelectorAll("div[data-upsell-target-id]");
                      //                 if (i.length > 0) {
                      //                     var a = i[0].getAttribute("data-upsell-target-id");
                      //                     a && (a = (a = (a = (a = (a = (a = (a = (a = a.replace("product_form_", "")).replace("upsell_product_form_", "")).replace("product-form-", "")).replace("product-template", "")).replace("AddToCartForm--", "")).replace("AddToCartForm-", "")).replace("js--", "")).replace(/\D/g, ""),
                      //                     isNaN(parseInt(a)) || t.getProductById(a).then(function(e) {
                      //                         var n = JSON.parse(e);
                      //                         n.products && n.products.length && (t.product = n.products[0],
                      //                         t.setTagsCollections("/products/".concat(t.product.handle)),
                      //                         t.page != w && setTimeout(function() {
                      //                             t.viewContentEvent()
                      //                         }, 500)),
                      //                         t.isLoadingProduct = !1
                      //                     }).catch(function(e) {
                      //                         t.isLoadingProduct = !1,
                      //                         n.consoleLog("loadProduct", e)
                      //                     }))
                      //                 }
                      //             }
                      //             t.isLoadingProduct = !1
                      //         }).catch(function(e) {
                      //             t.isLoadingProduct = !1,
                      //             n.consoleLog("loadProduct", e)
                      //         })))
                      //     }
                      //     if (null == this.product && "BetterCartCheckoutOffer" === this.page && (this.isLoadingProduct = !0,
                      //     U(window, "bcData.product") && this.getProductById(U(window, "bcData.product.product_id")).then(function(e) {
                      //         var n = JSON.parse(e);
                      //         n.products && n.products.length && (t.product = n.products[0],
                      //         t.isLoadingProduct = !1),
                      //         t.isLoadingProduct = !1
                      //     }).then(function() {
                      //         t.viewContentEvent()
                      //     }).catch(function() {
                      //         t.isLoadingProduct = !1
                      //     })),
                      //     null == this.product && 1 == document.getElementsByClassName("loox-rating").length) {
                      //         var l = document.getElementsByClassName("loox-rating")[0].getAttribute("data-id");
                      //         isNaN(parseInt(l)) || this.getProductById(l).then(function(e) {
                      //             var n = JSON.parse(e);
                      //             n.products && n.products.length && (t.product = n.products[0],
                      //             t.setTagsCollections("/products/".concat(t.product.handle)),
                      //             t.page != w && setTimeout(function() {
                      //                 t.viewContentEvent()
                      //             }, 500)),
                      //             t.isLoadingProduct = !1
                      //         }).catch(function(e) {
                      //             t.isLoadingProduct = !1,
                      //             n.consoleLog("loadProduct", e)
                      //         })
                      //     }
                      // }
                  }
              }
          }, {
              key: "getInCartUpsellProduct",
              value: function(t) {
                  var e = this;
                  t && (this.upsellInCartOnce = !1,
                  document.querySelectorAll("form[action='/cart/add'].variants").forEach(function(t) {
                      var n = t.querySelector('*[id^="product-select-"]').options[0].value;
                      console.log('getInCartUpsellProduct');
                      // parseInt(n) && N("".concat(e.backendURL, "/get/").concat(e.shopName, "/product/").concat(n, "/variant")).then(function() {
                      //     var n, o = (n = a.a.mark(function n(o) {
                      //         var i, r;
                      //         return a.a.wrap(function(n) {
                      //             for (; ; )
                      //                 switch (n.prev = n.next) {
                      //                 case 0:
                      //                     if (void 0 === (i = JSON.parse(o)).variant.product_id) {
                      //                         n.next = 6;
                      //                         break
                      //                     }
                      //                     return r = "upsell_product_form_".concat(i.variant.product_id),
                      //                     t.setAttribute("id", r),
                      //                     n.next = 6,
                      //                     e.getProductById(i.variant.product_id).then(function(t) {
                      //                         var n = JSON.parse(t);
                      //                         n.products && n.products.length && (e.product = n.products[0],
                      //                         e.consoleLog("upsell offer product set", e.product))
                      //                     }).catch(function(t) {
                      //                         e.consoleLog(t)
                      //                     });
                      //                 case 6:
                      //                 case "end":
                      //                     return n.stop()
                      //                 }
                      //         }, n)
                      //     }),
                      //     function() {
                      //         var t = this
                      //           , e = arguments;
                      //         return new Promise(function(o, i) {
                      //             var a = n.apply(t, e);
                      //             function r(t) {
                      //                 c(a, o, i, r, s, "next", t)
                      //             }
                      //             function s(t) {
                      //                 c(a, o, i, r, s, "throw", t)
                      //             }
                      //             r(void 0)
                      //         }
                      //         )
                      //     }
                      //     );
                      //     return function(t) {
                      //         return o.apply(this, arguments)
                      //     }
                      // }()).catch(function(t) {
                      //     e.consoleLog(t)
                      // })
                  }))
              }
          }, {
              key: "setCart",
              value: function(t) {
                  if (t) {
                      for (var e in this.cart || (this.cart = {}),
                      t)
                          t.hasOwnProperty(e) && (this.cart[e] = t[e]);
                      localStorage.setItem("TFX_CART", JSON.stringify(this.cart))
                  }
              }
          }, {
              key: "setCartFromStorage",
              value: function() {
                  var t = null;
                  if (!localStorage.getItem("TFX_CART"))
                      return t;
                  try {
                      this.cart = JSON.parse(localStorage.getItem("TFX_CART")),
                      this.consoleLog("Set cart from storage", this.cart),
                      t = !0
                  } catch (t) {
                      this.consoleLog(t)
                  }
                  return t
              }
          }, {
              key: "addToCart",
              value: function(t) {
                  if (t)
                      try {
                          var e = JSON.parse(localStorage.getItem("TFX_CART"));
                          e || (e = {
                              items: []
                          },
                          localStorage.setItem("TFX_CART", JSON.stringify(e)));
                          var n = this.getVariant(t);
                          n.line_price = this.shop.value_reporting ? this.calculatePrice(n.price) : "0.00",
                          n.quantity = document.getElementsByName("quantity")[0] ? document.getElementsByName("quantity")[0].value : 1,
                          n.product_type = t.product_type,
                          e.items.find(function(t) {
                              return t.id === n.id
                          }) || (e.items.push(n),
                          localStorage.setItem("TFX_CART", JSON.stringify(e))),
                          this.cart = e
                      } catch (t) {
                          this.consoleLog(t)
                      }
              }
          }, {
              key: "reloadCart",
              value: function() {
                  var t = this;
                  if (!this.isFetchingCart && 0 !== this.reloadCartAttemps) {
                      this.isFetchingCart = !0;
                      var e = U(this.cart, "item_count");
                      N("".concat(this.shopHost, "/cart.json")).then(function(n) {
                          var o = JSON.parse(n);
                          t.isFetchingCart = !1,
                          o && (t.consoleLog("data.items.length", e),
                          o.item_count === e ? (t.reloadCartAttemps--,
                          setTimeout(function() {
                              t.reloadCart()
                          }, 500)) : (t.cart = o,
                          localStorage.setItem("TFX_CART", JSON.stringify(o))))
                      }).catch(function(e) {
                          t.consoleLog(e),
                          t.isFetchingCart = !1
                      })
                  }
              }
          }, {
              key: "loadCart",
              value: function() {
                  var t = this;
                  if (!this.isFetchingCart) {
                      this.isFetchingCart = !0;
                      var e = theme.tfxCart || null;
                      e ? (this.cart = e,
                      localStorage.setItem("TFX_CART", JSON.stringify(e)),
                      this.isFetchingCart = !1) : this.setCartFromStorage() ? this.isFetchingCart = !1 : N("".concat(this.shopHost, "/cart.json")).then(function(e) {
                          var n = JSON.parse(e);
                          t.isFetchingCart = !1,
                          n && (t.cart = n,
                          localStorage.setItem("TFX_CART", JSON.stringify(n)))
                      }).catch(function(e) {
                          t.consoleLog(e),
                          t.isFetchingCart = !1
                      })
                  }
              }
          }, {
              key: "saveCartProduct",
              value: function(t) {
                  if (t)
                      try {
                          var e = JSON.parse(F("TFX_ATC"));
                          e.push(t),
                          I("TFX_ATC", JSON.stringify(s(new Set(e))), {
                              "max-age": 1209600
                          })
                      } catch (e) {
                          I("TFX_ATC", JSON.stringify([t]), {
                              "max-age": 600
                          })
                      }
              }
          }, {
              key: "getSavedCartProducts",
              value: function() {
                  var t = [];
                  try {
                      t = JSON.parse(F("TFX_ATC"))
                  } catch (t) {
                      this.consoleLog(t)
                  }
                  return t || []
              }
          }, {
              key: "setAdvanceMatchingData",
              value: function() {
                  this.page === E || this.page === k ? U(window, "Shopify.checkout.shipping_address") ? this.setUser({
                      em: U(window, "Shopify.checkout.email"),
                      fn: U(window, "Shopify.checkout.shipping_address.first_name") ? U(window, "Shopify.checkout.shipping_address.first_name").toLowerCase() : "",
                      ln: U(window, "Shopify.checkout.shipping_address.last_name") ? U(window, "Shopify.checkout.shipping_address.last_name").toLowerCase() : "",
                      ct: U(window, "Shopify.checkout.shipping_address.city") ? U(window, "Shopify.checkout.shipping_address.city").toLowerCase().replace(/\s+/g, "") : "",
                      zp: U(window, "Shopify.checkout.shipping_address.zip") ? U(window, "Shopify.checkout.shipping_address.zip").replace(/\D/g, "") : "",
                      ph: x(window, "Shopify.checkout.shipping_address.phone") ? U(window, "Shopify.checkout.shipping_address.phone").replace(/[^0-9]/g, "") : null
                  }) : U(window, "Shopify.checkout.billing_address") ? this.setUser({
                      em: U(window, "Shopify.checkout.email"),
                      fn: U(window, "Shopify.checkout.billing_address.first_name") ? U(window, "Shopify.checkout.billing_address.first_name").toLowerCase() : "",
                      ln: U(window, "Shopify.checkout.billing_address.last_name") ? U(window, "Shopify.checkout.billing_address.last_name").toLowerCase() : "",
                      ct: U(window, "Shopify.checkout.billing_address.city") ? U(window, "Shopify.checkout.billing_address.city").toLowerCase().replace(/\s+/g, "") : "",
                      zp: U(window, "Shopify.checkout.billing_address.zip") ? U(window, "Shopify.checkout.billing_address.zip").replace(/\D/g, "") : "",
                      ph: x(window, "Shopify.checkout.billing_address.phone") ? U(window, "Shopify.checkout.billing_address.phone").replace(/[^0-9]/g, "") : null
                  }) : this.setUser({
                      em: U(window, "Shopify.checkout.email"),
                      fn: "",
                      ln: "",
                      ct: "",
                      zp: "",
                      ph: ""
                  }) : this.page === P && U(window, "bcData.order.shipping_address") && this.setUser({
                      em: U(window, "bcData.order.customer.email"),
                      fn: U(window, "bcData.order.shipping_address.first_name") ? U(window, "bcData.order.shipping_address.first_name").toLowerCase() : "",
                      ln: U(window, "bcData.order.shipping_address.last_name") ? U(window, "bcData.order.shipping_address.last_name").toLowerCase() : "",
                      ct: U(window, "bcData.order.shipping_address.city") ? U(window, "bcData.order.shipping_address.city").toLowerCase().replace(/\s+/g, "") : "",
                      zp: U(window, "bcData.order.shipping_address.zip") ? U(window, "bcData.order.shipping_address.zip").replace(/\D/g, "") : "",
                      ph: x(window, "bcData.order.customer.phone") ? U(window, "bcData.order.customer.phone").replace(/[^0-9]/g, "") : ""
                  })
              }
          }, {
              key: "getAdvanceMatchingData",
              value: function() {
                  if (this.setAdvanceMatchingData(),
                  !this.shop.advance_matching || !this.advanceMatching)
                      return {};
                  var t = this.getUser()
                    , e = {};
                  for (var n in t)
                      t.hasOwnProperty(n) && t[n] && "".concat(t[n]).trim() && (e[n] = t[n].replace(/\s+/g, ""));
                  if (e.country) {
                      var o = Object.keys(L)[Object.values(L).indexOf(e.country.toLowerCase().replace(/\s/g, ""))];
                      e.country = o ? o.toLowerCase() : ""
                  }
                  e.em&&(e.em = e.em.toLowerCase().replace(/\s+/g, ""));
                  e.ph&&(e.ph = e.ph.replace(/\s+/g, "").match(/[0-9]/g).join(''));
                  e.ct&&(e.ct = e.ct.toLowerCase().replace(/\s+/g, ""));
                  e.zp&&(e.zp = e.zp.toLowerCase().replace(/\s+/g, "").replace(/\-/g, ''));
                  e.st&&(e.st = e.st.toLowerCase().replace(/\s+/g, ""));
                  if(Shopify.checkout&&Shopify.checkout.shipping_address){
                      let ShippingAddress = Shopify.checkout.shipping_address;
                      !e.country&&ShippingAddress.country_code&&(e.country = ShippingAddress.country_code.toLowerCase().replace(/\s+/g, ""));	
                      !e.st&&ShippingAddress.province&&(e.st = ShippingAddress.province.toLowerCase().replace(/\s+/g, ""));	
                      !e.zp&&ShippingAddress.zip&&(e.zp = ShippingAddress.zip.toLowerCase().replace(/\s+/g, "").replace(/\-/g, ''));	
                      !e.ct&&ShippingAddress.city&&(e.ct = ShippingAddress.city.toLowerCase().replace(/\s+/g, ""));
                      !e.ph&&ShippingAddress.phone&&(e.ph = ShippingAddress.phone.replace(/\s+/g, "").match(/[0-9]/g).join(''));
                      !e.fn&&ShippingAddress.first_name&&(e.fn = ShippingAddress.first_name.trim().toLowerCase()); 
                      !e.ln&&ShippingAddress.last_name&&(e.ln = ShippingAddress.last_name.trim().toLowerCase());                         
                  }
                  let PIXELDATA =  localStorage.getItem('PIXELDATA');
                  if(PIXELDATA) {
                      PIXELDATA = JSON.parse(PIXELDATA);
                      !e.em&&PIXELDATA.em&&(e.em = PIXELDATA.em.toLowerCase().replace(/\s+/g, ""));
                      !e.ph&&PIXELDATA.ph&&(e.ph = PIXELDATA.ph.replace(/\s+/g, "").match(/[0-9]/g).join(''));
                      !e.fn&&PIXELDATA.fn&&(e.fn = PIXELDATA.fn.trim().toLowerCase());
                      !e.ln&&PIXELDATA.ln&&(e.ln = PIXELDATA.ln.trim().toLowerCase());
                      !e.ct&&PIXELDATA.ct&&(e.ct = PIXELDATA.ct.toLowerCase().replace(/\s+/g, ""));
                      !e.st&&PIXELDATA.st&&(e.st = PIXELDATA.st.toLowerCase().replace(/\s+/g, ""));
                      !e.zp&&PIXELDATA.zp&&(e.zp = PIXELDATA.zp.toLowerCase().replace(/\s+/g, "").replace(/\-/g, ''));
                      !e.country&&PIXELDATA.country&&(e.country = PIXELDATA.country.toLowerCase().replace(/\s+/g, ""));                          
                  }
                  !e.external_id && (e.external_id = A(window, "ShopifyAnalytics.lib.user") ? window.ShopifyAnalytics.lib.user().traits().uniqToken : "");
                  !e.country && this.client_ip_address.countryCode && (e.country = this.client_ip_address.countryCode.toLowerCase().replace(/\s+/g, ""));
                  !e.st && this.client_ip_address.region && (e.st = this.client_ip_address.region.toLowerCase().replace(/\s+/g, ""));
                  !e.zp && this.client_ip_address.zip && (e.zp = this.client_ip_address.zip.toLowerCase().replace(/\s+/g, "").replace(/\-/g, ''));
                  !e.ct && this.client_ip_address.city && (e.ct = this.client_ip_address.city.toLowerCase().replace(/\s+/g, ""));
                  localStorage.setItem('PIXELDATA', JSON.stringify({
                      em: e.em, ph: e.ph, fn: e.fn, ln: e.ln, ct: e.ct, st: e.st, zp: e.zp, country: e.country ? e.country.toLowerCase : e.country
                  }))

                  return e;
              }
          }, {
              key: "filterPixels",
              value: function() {
                  var t = this;
                  return t.consoleLog("Tags: ".concat(t.tags)),
                  t.consoleLog("Collections: ".concat(t.collections)),
                  t.pixels = t.shop.pixels.filter(function(e) {
                      var n = e.context ? e.context.filter(function(e) {
                          return -1 !== t.tags.indexOf(e.trim())
                      }) : []
                        , o = e.context ? e.context.filter(function(e) {
                          return -1 !== t.collections.indexOf(e.trim())
                      }) : [];
                      return t.consoleLog("".concat(e.pixel_id, " - Matched Tags ").concat(n.join(", "), ", Matched Collections ").concat(o.join(", "))),
                      "master" === e.type || "tag" === e.type && n.length || "collection" === e.type && o.length
                  }),
                  t.pixels.length
              }
          }, {
              key: "initPixels",
              value: function() {//t.pageViewEvent(n.pixel_id)
                  var t = this
                    , e = t.getAdvanceMatchingData();
                  t.pixels.forEach(function(n) {
                      "geo" === t.shop.ccpa && fbq("dataProcessingOptions", ["LDU"], 0, 0),
                      "disabled" === t.shop.ccpa && fbq("dataProcessingOptions", []),
                      fbq("set", "autoConfig", false, n.pixel_id),
                      -1 === t.initializedPixels.indexOf(n.pixel_id) && (fbq("init", n.pixel_id, e),
                      t.initializedPixels.push(n.pixel_id),
                      t.consoleLog(" Init Pixel: ".concat(n.pixel_id, ", Type: ").concat(n.type)),
                      t.shop.shopify_pixel && t.pageViewEvent(n.pixel_id))
                  })
              }
          }, {
              key: "saveEmptyUser",
              value: function() {
                  var userData = this.getUser();
                  var t = F('_shopify_y') || ""
                    , e = {
                      fbc: F("_fbc") || F("as_fbc"),
                      fbp: F("_fbp") || F("as_fbp"),
                      em: userData.em || "",
                      fn: userData.fn || "",
                      ln: userData.ln || "",
                      ph: "",
                      external_id: t,
                      ge: "",
                      db: "",
                      ct: "",
                      st: "",
                      zp: "",
                      country: "",
                      la: "",
                      ...theme.fbData
                  };
                  try {
                      var n = localStorage.getItem("TFX_USER_DATA")
                        , o = JSON.parse(n);
                      if (o)
                          for (var i in o)
                              o.hasOwnProperty(i) && o[i].length && (e[i] = o[i])
                  } catch (t) {
                      this.consoleLog("ERROR ON PARSE USER DATA", t)
                  }
                  return localStorage.setItem("TFX_USER_DATA", JSON.stringify(e)),
                  e
              }
          }, {
              key: "getUser",
              value: function() {
                  try {
                      return JSON.parse(localStorage.getItem("TFX_USER_DATA")) || {}
                  } catch (t) {
                      this.consoleLog("User Data Parse Error")
                  }
                  return {}
              }
          }, {
              key: "setUser",
              value: function(t) {
                  if (t) {
                      var e = this.getUser();
                      for (var n in t)
                          t.hasOwnProperty(n) && t[n] && "".concat(t[n]).trim() && (e[n] = t[n]);
                      this.user = e,
                      localStorage.setItem("TFX_USER_DATA", JSON.stringify(e)),
                      this.consoleLog("User data is saved:", e)
                  }
              }
          }, {
              key: "setUTMs",
              value: function() {
                  var t = {}
                    , e = new URLSearchParams(window.location.search)
                    , n = !0
                    , o = !1
                    , i = void 0;
                  try {
                      for (var a, r = e[Symbol.iterator](); !(n = (a = r.next()).done); n = !0) {
                          var c = a.value;
                          c[0].startsWith("utm_") && (t[c[0].replace("utm_", "")] = c[1])
                      }
                  } catch (t) {
                      o = !0,
                      i = t
                  } finally {
                      try {
                          n || null == r.return || r.return()
                      } finally {
                          if (o)
                              throw i
                      }
                  }
                  Object.keys(t).length > 0 && localStorage.setItem("TFX_UTM", JSON.stringify(t))
              }
          }, {
              key: "getUTMs",
              value: function() {
                  try {
                      return JSON.parse(localStorage.getItem("TFX_UTM"))
                  } catch (t) {
                      return this.consoleLog(" ERROR on parse utm tags"),
                      {}
                  }
              }
          }, {
              key: "fireEvents",
              value: function() {
                  switch (this.shop.shopify_pixel || this.pageViewEvent(),
                  this.page) {
                  case "PageFly":
                  case T:
                  case "Shogun":
                      window.__shgProducts && this.ShogunViewContentEvent();
                      break;
                  case w:
                      this.viewContentEvent();
                      break;
                  case S:
                      this.zipifyViewContentEvent();
                      break;
                  case C:
                      this.viewCategoryEvent();
                      break;
                  case P:
                      this.purchaseEvent(U(this.checkout, "line_items"));
                      break;
                  case "Cart":
                      this.triggerMissedAtcEvents(),
                      this.viewCartEvent();
                      break;
                  case "Checkout":
                      this.initiateCheckoutEvent(),
                      this.ocuClearCookies();
                      break;
                  case k:
                      this.shop.orders_purchase && this.purchaseEvent(U(this.checkout, "line_items"));
                      break;
                  case E:
                      this.purchaseEvent(U(this.checkout, "line_items"));
                      break;
                  case "OCUThankYou":
                      this.ocuPurchaseEvent();
                      break;
                  case "UpSellPage":
                      this.ocuViewContentEvent(),
                      this.ocuPurchaseEvent();
                      break;
                  case "CartHookCheckout":
                      this.cartHookInitiateCheckoutEvent();
                      break;
                  case "CartHookThankYou":
                      this.cartHookPurchaseEvent(this.page);
                      break;
                  case "CartHookUpSellPage":
                  case "CartHookDownSellPage":
                      this.cartHookPurchaseEvent(this.page),
                      this.cartHookViewContentEvent();
                      break;
                  case "CartHookPage":
                      this.cartHookViewContentEvent();
                      break;
                  case b:
                      this.searchEvent({
                          q: O("q")
                      })
                  }
              }
          }, {
              key: "attachListeners",
              value: function() {
                  this.isEventsAttached = !0,
                  this.listenSubmitsEvent(),
                  this.listenModalOpenEvent(),
                  this.listenFormChangeEvent(),
                  this.listenDocumentClickEvent(),
                  this.listenSpecialElements(10),
                  this.listenElementsClickEvent(),
                  this.listenTouchEvent(),
                  this.listenPushStateEvent(),
                  this.listenRequests(),
                  this.listenBlurEvent(10)
              }
          }, {
              key: "testRequest",
              value: function(t) {
                  return N("https://tfx-bizspice.ngrok.io/?event=".concat(t.event, "&data=").concat(JSON.stringify(t.data))).then().catch()
              }
          }, {
              key: "fire",
              value: function(t, e, n, o, i, a) {
                  var r = o ? "trackSingleCustom" : "trackSingle"
                    , c = null;
                  //   console.log('fire', t);
                  if (-1 !== [m].indexOf(t)) {
                      var s = n.order_id || U(window, "Shopify.checkout.order_id") || null;
                      if (s) {
                          if (F("".concat(s)))
                              return;
                          if (
                          // N("".concat(this.backendURL, "/shop-orders/").concat(this.shopName, "?order_id=").concat(s), {
                          //     method: "GET"
                          // }).then().catch(console.log),
                          this.getUser().hasOwnProperty("fbc") || this.getUser().hasOwnProperty("fbp") || this.getUser().hasOwnProperty("external_id")) {
                              var u = this.getUser().hasOwnProperty("fbc") ? this.getUser().fbc : ""
                                , l = this.getUser().hasOwnProperty("fbp") ? this.getUser().fbp : ""
                                , d = this.getUser().hasOwnProperty("external_id") ? this.getUser().external_id : "";
                              // N("".concat(this.backendURL, "/save_fbp_fbc/").concat(this.shopName, "?order_id=").concat(s, "&fbc=").concat(u, "&fbp=").concat(l, "&external_id=").concat(d), {
                              //     method: "GET"
                              // }).then().catch(console.log)
                          }
                          a || I("".concat(s), !0, {
                              "max-age": 2592e3
                          }),
                          c = {
                              eventID: "".concat(s)
                          }
                      }
                  }
                  if (-1 !== [v, f, y].indexOf(t)) {
                      var h = Math.floor(9e4 * Math.random()) + 1e4
                        , p = Math.random().toString(36).substring(2) + "_" + h + "_" + (new Date).getTime();
                      this.shop && (p = p + "_" + this.shop.shop_id),
                      c = {
                          eventID: p
                      }
                  }
                  n && !this.shop.contents && n.contents && delete n.contents,
                  e && (i ? fbq(r, i, t, n, c) : this.pixels.forEach(function(e) {
                      // console.log('==========fbq==========', r, e.pixel_id, t, n, c);
                      return fbq(r, e.pixel_id, t, n, c)
                  }),
                  t === g && (this.pageViewFired = !0),
                  this.consoleLog('Fired : "'.concat(t, '" (').concat(r, ") with data:"), n)),
                  -1 === [g, _].indexOf(t) && this.log(t, n, c)
              }
          }, {
              key: "log",
              value: function(t, e, n) {
                  var o = this;
                  // console.log('/log', e);
                  if (this.shop.logging && e) {
                      if (t === m) {
                          var i = e.content_name.toLowerCase();
                          (i.includes("upsellpurchase") || i.includes("downsellpurchase")) && (t = "PurchUpDown"),
                          i.includes("initial") && (t = "PurchInitial")
                      }
                      var a = [];
                      this.tags && this.tags.length && (a = s(new Set(this.tags.map(function(t) {
                          return "string" == typeof t ? t.toString().trim() : t
                      }).filter(function(t) {
                          return "" !== t.trim()
                      }))));
                      var c = [];
                      this.collections && this.collections.length && (c = s(new Set(this.collections.map(function(t) {
                          return "string" == typeof t ? t.toString().trim() : t
                      }).filter(function(t) {
                          return "" !== t.trim()
                      }))));
                      var u = "";
                      "object" === ("undefined" == typeof navigator ? "undefined" : r(navigator)) && (u = navigator.userAgent ? navigator.userAgent : "");
                      var l = {
                          ev: t,
                          evId: e.order_id || null,
                          si: this.shop.shop_id,
                          us: this.getUser(),
                          cr: this.shop.currency,
                          px: this.pixels.map(function(t) {
                              return t.pixel_id
                          }),
                          cx: {
                              tags: a.splice(0, 50),
                              collections: c.splice(0, 50)
                          },
                          vl: U(e, "value") || 0,
                          pr: this.productIds,
                          ds: U(e, "discount") || 0,
                          ut: this.getUTMs() || {},
                          url: "".concat(window.location.origin).concat(window.location.pathname),
                          device: j(),
                          problems: this.getProblems(t),
                          content_name: e.content_name,
                          dirtyTags: this.tags,
                          uip: o.client_ip_address.query || this.shop.user_ip,
                          uua: u,
                          sn: this.shop.shop,
                          splan: this.shop.tfx_planName
                      }
                        , d = this.getAdvanceMatchingData();
                      null != d.external_id && "" != d.external_id || (this.getUserExternalId(),
                      d = this.getAdvanceMatchingData()),
                      t !== v && t !== f && t !== y && t !== m ||  (l.evId = n.eventID,
                      l.ssed = e,
                      l.ts = (new Date).toISOString(),
                      l.ss = this.pixels.map(function(t) {
                          return {
                              pixel: t.pixel_id,
                              ss: t.serversideapi_enabled
                          }
                      }),
                      l.am = d),
                      t === m && (l.am = d),
                      this.queueLog(l),
                      NN("".concat(this.backendURL, "/aha-web/conversion/push"), {
                          method: "POST",
                          body: JSON.stringify(l)
                      }).then(function(t) {
                          o.consoleLog("LOGGED data", l, "Response", t),
                          o.removeFromLogQueue(l)
                      }).catch(function(t) {
                          o.consoleLog("TFX:", t)
                      })
                  }
              }
          }, {
              key: "getProblems",
              value: function(t) {
                  var e = null;
                  if (t === m && !this.tags.length) {
                      var n = document.querySelector('meta[name="tfx:tags"]');
                      n && (this.tags = n.content);
                      var o = 1;
                      try {
                          localStorage.setItem("test", "test"),
                          localStorage.removeItem("test"),
                          o = 1
                      } catch (t) {
                          o = t.message
                      }
                      e = {
                          liquidTags: document.querySelector('meta[name="tfx:tags"]') ? document.querySelector('meta[name="tfx:tags"]').content : null,
                          page: this.page,
                          isLocalStorageWorking: o
                      }
                  }
                  return e
              }
          }, {
              key: "removeFromLogQueue",
              value: function(t) {
                  var e = null;
                  try {
                      e = (e = JSON.parse(localStorage.getItem("TFX_LOG_QUEUE"))).splice(1, e.indexOf(t)),
                      localStorage.setItem("TFX_LOG_QUEUE", JSON.stringify(e))
                  } catch (e) {
                      this.consoleLog(e),
                      localStorage.setItem("TFX_LOG_QUEUE", JSON.stringify([t]))
                  }
              }
          }, {
              key: "queueLog",
              value: function(t) {
                  var e = null;
                  try {
                      (e = JSON.parse(localStorage.getItem("TFX_LOG_QUEUE"))).push(t),
                      localStorage.setItem("TFX_LOG_QUEUE", JSON.stringify(e))
                  } catch (e) {
                      localStorage.setItem("TFX_LOG_QUEUE", JSON.stringify([t]))
                  }
              }
          }, {
              key: "deleteATCqueue",
              value: function(t) {
                  if (t) {
                      var e = null;
                      try {
                          (e = JSON.parse(localStorage.getItem("TFX_QUEUE_ATC"))).splice(e.indexOf(t), 1),
                          localStorage.setItem("TFX_QUEUE_ATC", JSON.stringify(s(new Set(e))))
                      } catch (t) {
                          this.consoleLog(t)
                      }
                  }
              }
          }, {
              key: "queueATC",
              value: function(t) {
                  if (t) {
                      var e = null;
                      try {
                          (e = JSON.parse(localStorage.getItem("TFX_QUEUE_ATC"))).push(t),
                          localStorage.setItem("TFX_QUEUE_ATC", JSON.stringify(s(new Set(e))))
                      } catch (e) {
                          localStorage.setItem("TFX_QUEUE_ATC", JSON.stringify([t]))
                      }
                  }
              }
          }, {
              key: "triggerMissedAtcEvents",
              value: function() {
                  var t = this
                    , e = !0;
                  this.isIOS14 && !this.addToCartEventFire && (this.consoleLog("IOS14: Add To Cart Event Restricted"),
                  e = !1);
                  var n = this;
                  if (this.cart && this.cart.items) {
                      var o = this.getSavedCartProducts();
                      this.cart.items.forEach(function(i) {
                          -1 === o.indexOf(i.handle) && (i.id = i.product_id,
                          n.getTagsCollections(i.url).then(function(o) {
                              var a = t.extractTagsCollections(o)
                                , r = a.tags
                                , c = a.collections
                                , s = n.getProductData(v, i, r, c);
                              n.fire(v, e, s),
                              n.saveCartProduct(i.handle)
                          }).catch(t.consoleLog))
                      })
                  }
              }
          }, {
              key: "triggerATCQueue",
              value: function() {
                  var t = this
                    , e = this
                    , n = null
                    , o = this.getSavedCartProducts()
                    , i = !0;
                  this.isIOS14 && !this.addToCartEventFire && (this.consoleLog("IOS14: Add To Cart Event Restricted"),
                  i = !1);
                  try {
                      (n = JSON.parse(localStorage.getItem("TFX_QUEUE_ATC"))).length && n.forEach(function(n) {
                          -1 === o.indexOf(n) ? e.getProduct(n).then(function(o) {
                              try {
                                  var a = JSON.parse(o).product;
                                  e.getTagsCollections(n).then(function(o) {
                                      var r = t.extractTagsCollections(o)
                                        , c = r.tags
                                        , s = r.collections
                                        , u = e.getProductData(v, a, c, s);
                                      e.fire(v, i, u),
                                      e.deleteATCqueue(n)
                                  }).catch(t.consoleLog)
                              } catch (e) {
                                  t.consoleLog(e)
                              }
                          }) : e.deleteATCqueue(n)
                      })
                  } catch (t) {}
              }
          }, {
              key: "triggerQueue",
              value: function() {
                  var t = this
                    , e = null;
                  try {
                      (e = JSON.parse(localStorage.getItem("TFX_LOG_QUEUE"))).length && e.forEach(function(e) {
                          NN("".concat(t.backendURL, "/aha-web/conversion/push"), {
                              method: "POST",
                              body: JSON.stringify(d({}, e, {
                                  isTriggeredFromQueue: 1
                              }))
                          }).then(function(n) {
                              t.removeFromLogQueue(e)
                          }).catch(function(e) {
                              t.consoleLog("TFX:", e)
                          })
                      })
                  } catch (t) {}
              }
          }, {
              key: "trackTime",
              value: function() {
                  var t = this;
                  setInterval(function() {
                      t.timeOnPage += 5,
                      t.timeOnSite += 5,
                      localStorage.setItem("TFX_TIME_ON_SITE", t.timeOnSite),
                      t.timerEvent()
                  }, 5e3)
              }
          }, {
              key: "calculatePrice",
              value: function(t, e) {
                  if (!t)
                      return 0;
                  var n = e || -1 !== t.toString().indexOf(".") ? t : t / 100;
                  return parseFloat(n / 100 * this.shop.reporting_percentage).toFixed(2)
              }
          }, {
              key: "getVariant",
              value: function(t) {
                  var e = null
                    , n = O("variant") || U(window, "ShopifyAnalytics.meta.selectedVariantId");
                  if (n && parseInt(n)) {
                      var o = U(window, "ShopifyAnalytics.meta.product.variants");
                      if (o && (e = o.find(function(t) {
                          return t.id === parseInt(n)
                      })))
                          return e
                  }
                  return this.consoleLog("V", e),
                  !e && t.variants && t.variants.length && (e = t.variants[0]),
                  e || t
              }
          }, {
              key: "getProductData",
              value: function(t, e, n, o) {
                  if (!e)
                      return null;
                  var i = this.getVariant(e);
                  this.consoleLog("Selected Variant", i);
                  var a = document.getElementsByName("quantity")[0] ? document.getElementsByName("quantity")[0].value : 1
                    , r = this.shop.report_variants ? i.id : e.id
                    , c = U(window, "ShopifyAnalytics.meta.selectedVariantId");
                  return this.productIds = [e.id],
                  {
                      // content_name: "Trackify ".concat(this.eventPrefix, " ").concat(t, ": ").concat(this.printTags(n)),
                      content_name: i.name,
                      content_type: this.shop.report_variants && e.variants.length ? "product" : "product_group",
                      content_ids: this.shop.report_variants && (parseInt(c) || i.id) || e.id,
                      content_category: U(e, "product_type") || U(e, "type") || "",
                      content_timedata: D(),
                      // content_collections: this.printCollections(o),
                      value: this.shop.value_reporting ? this.calculatePrice(i.price) : "0.00",
                      currency: U(window, "ShopifyAnalytics.meta.currency") || this.shop.currency || "USD",
                      contents: [{
                          product_id: r,
                          price: this.calculatePrice(e.price),
                          quantity: a
                      }]
                  }
              }
          }, {
              key: "getCartProductsData",
              value: function(t, e) {
                  var n = this;
                  if (!this.cart)
                      return null;
                  var o = this
                    , i = e || !1;
                  return this.productIds = this.cart.items.map(function(t) {
                      return t.product_id || t.id
                  }),
                  {
                      // content_name: "Trackify1 ".concat(this.eventPrefix, " ").concat(t, " : ").concat(this.printTags()),
                      content_name: s(new Set(this.cart.items.map(function(t) {
                          return t.title
                      }))).join(", "),
                      content_type: this.shop.report_variants ? "product" : "product_group",
                      content_ids: this.cart.items.map(function(t) {
                          return o.shop.report_variants ? t.id : t.product_id || t.id
                      }),
                      content_category: s(new Set(this.cart.items.map(function(t) {
                          return t.product_type
                      }))).join(", "),
                      content_timedata: D(),
                      // content_collections: this.printCollections(),
                      value: this.shop.value_reporting ? this.calculatePrice(this.cart.original_total_price, i) : "0.00",
                      currency: U(window, "ShopifyAnalytics.meta.currency") || this.cart.currency || "USD",
                      // contents: this.cart.items.map(function(t) {
                      //     return {
                      //         id: o.shop.report_variants ? t.id : t.product_id || t.id,
                      //         name: t.title,
                      //         quantity: t.quantity,
                      //         currency: U(window, "ShopifyAnalytics.meta.currency") || n.cart.currency || "USD",
                      //         price: o.calculatePrice(t.line_price),
                      //         item_category: t.product_type
                      //     }
                      // }),
                      // discount: this.cart.total_discount || 0,
                      contents: this.cart.items.map(function(t) {
                          return {
                              product_id: t.product_id || t.id,
                              quantity: t.quantity,
                              price: o.calculatePrice(t.price)
                          }
                      }),
                      num_items: this.cart.item_count
                  }
              }
          }, {
              key: "getPurchaseData",
              value: function(t, e) {
                  if (!t)
                      return this.consoleLog("No Items found for trigger purchase"),
                      null;
                  var n = this
                    , o = null
                    , i = []
                    , a = []
                    , r = [];
                  this.productIds = [];
                  t.forEach(function(t) {
                      n.cart && (o = n.cart.items.find(function(e) {
                          return e.variant_id === t.variant_id
                      })) && r.push(o.product_type),
                      n.productIds.push(t.product_id || t.id),
                      a.push(n.shop.report_variants && t.variant_id ? t.variant_id : t.product_id || t.id),
                      i.push({
                          product_id: n.shop.report_variants && t.variant_id ? t.variant_id : t.product_id || t.id,
                          quantity: t.quantity,
                          price: n.calculatePrice(t.price, !0)
                      })
                  });
                  return ({
                      content_name: s(new Set(t.map(function(v) {
                          return v.title
                      }))).join(", "),
                      content_type: this.shop.report_variants ? "product" : "product_group",
                      content_ids: a,
                      content_category: s(new Set(r)).join(", "),
                      content_timedata: D(),
                      // content_collections: this.printCollections(),
                      value: this.calculatePrice(U(this, "checkout.total_price") || n.cart.original_total_price, !0),
                      currency: U(window, "ShopifyAnalytics.meta.currency") || this.shop.currency || "USD",
                      contents: i,
                      num_items: (U(this, "checkout.line_items") || t || []).length,
                      // discount: U(this, "checkout.discount") || 0,
                      order_id: U(this, "checkout.order_id") || U(this, "interCartEvent.additional.transaction_id") || U(window, "chData.order.order_id")
                  })
              }
          }, {
              key: "getTimerData",
              value: function() {
                  return {
                      content_timeonpage: this.timeOnPage,
                      content_timeonsite: this.timeOnSite,
                      content_page: this.page
                  }
              }
          }, {
              key: "listenSpecialElements",
              value: function(t) {
                  var e = this
                    , n = this
                    , o = ['button[type*="submit"]', 'input[type*="submit"]', "button.btn-addtocart", 'button[type="button"][data-label="Add to Cart"]', "[id^=buttonapp]", "button.b-app__ATC-btn"].map(function(t) {
                      return 'form[action="/cart/add"] '.concat(t, ':not([style*="display:none"])')
                  }).concat(['#mst-stiky-box button[name="add"]', "#copyAddtoCartMobile", '.buy-me-btn button[type="submit"]', ".zpa-add-to-cart-btn.zp"])
                    , i = document.querySelectorAll(o.join(","));
                  i.length ? i.forEach(function(t) {
                      // R(t, "click mousedown touch", function() {
                      //     console.log('===listenSpecialElements===');
                      //     if (e.page === S) {
                      //         var t = document.querySelector("form[data-zp-product-url]")
                      //           , o = t.getAttribute("data-productid");
                      //         t && o && (e.zipifyAddToCartEvent({
                      //             id: parseInt(o)
                      //         }),
                      //         t.getAttribute("data-zp-link-type") && "checkout" == t.getAttribute("data-zp-link-type") && n.initiateCheckoutEvent(),
                      //         n.consoleLog("method: listenSpecialElements called: zipifyAddToCartEvent"))
                      //     } else
                      //         "Cart" === e.page && document.querySelectorAll("form[action='/cart/add'].variants") ? (e.addToCartEvent(!0),
                      //         n.consoleLog("method: listenSpecialElements called: addToCartEvent")) : (e.addToCartEvent(!0),
                      //         n.initiateCheckoutEvent(),
                      //         n.consoleLog("method: listenSpecialElements called: addToCartEvent"))
                      // })
                  }) : t > 0 && setTimeout(function() {
                      e.listenSpecialElements(--t)
                  }, 400)
              }
          }, {
              key: "isCartEndpoint",
              value: function(url, name) {
                  if (!url) return false;
                  var path = String(url);
                  try {
                      path = new URL(url, window.location.origin).pathname
                  } catch (e) {}
                  return name === "add" ? path.indexOf("/cart/add") > -1 : path.indexOf("/cart/change") > -1
              }
          }, {
              key: "productFromCartLine",
              value: function(line) {
                  if (!line || !line.product_id) return null;
                  return {
                      id: line.product_id,
                      handle: line.handle,
                      product_type: line.product_type || "",
                      title: line.product_title || line.title,
                      price: line.price,
                      variants: [{
                          id: line.variant_id || line.id,
                          price: line.price,
                          name: line.title || line.product_title
                      }]
                  }
              }
          }, {
              key: "handleCartAddResponse",
              value: function(data) {
                  if (!data || data.status) return;
                  var line = data.product_id ? data : (data.items && data.items.length ? data.items[data.items.length - 1] : null);
                  if (window.productJSON) {
                      this.zipifyAddToCartEvent({
                          id: (line || data).id
                      });
                      return
                  }
                  if (!this.product && line && line.product_id)
                      this.product = this.productFromCartLine(line);
                  this.product ? this.addToCartEvent() : line && line.handle && this.queueATC(line.handle)
              }
          }, {
              key: "listenRequests",
              value: function() {
                  if ("PageFly" !== this.page && "Shogun" !== this.page) {
                      var t, e, n = this;
                      t = XMLHttpRequest.prototype.open,
                      XMLHttpRequest.prototype.open = function(e, reqUrl) {
                          if (-1 !== reqUrl.indexOf("ref=tfx"))
                              return t.apply(this, arguments),
                              !0;
                          var i = this;
                          i.addEventListener("readystatechange", function t() {
                              4 === i.readyState && (o(i, e, reqUrl),
                              i.removeEventListener("readyStateChange", t))
                          }),
                          t.apply(i, arguments)
                      }
                      ,
                      e = XMLHttpRequest.prototype.send,
                      XMLHttpRequest.prototype.send = function() {
                          var t = this;
                          t.requestData = arguments[0],
                          e.apply(t, arguments)
                      };
                      if (!window.__tfxFetchHooked) {
                          window.__tfxFetchHooked = !0;
                          var origFetch = window.fetch;
                          window.fetch = function(input, init) {
                              var url = "string" == typeof input ? input : input && input.url || ""
                                , method = (init && init.method) || (input && input.method) || "GET";
                              return origFetch.apply(this, arguments).then(function(res) {
                                  if (n.isCartEndpoint(url, "add") && "POST" === String(method).toUpperCase())
                                      res.clone().json().then(function(data) {
                                          n.handleCartAddResponse(data)
                                      }).catch(function() {});
                                  if (n.isCartEndpoint(url, "change") && "POST" === String(method).toUpperCase())
                                      try {
                                          n.reloadCart()
                                      } catch (err) {}
                                  return res
                              })
                          }
                      }
                  }
                  function o(t, e, reqUrl) {
                      if (n.isCartEndpoint(reqUrl, "add") && "POST" === e) {
                          try {
                              n.handleCartAddResponse(JSON.parse(t.response))
                          } catch (err) {}
                      }
                      if (n.isCartEndpoint(reqUrl, "change") && "POST" === e) {
                          try {
                              n.reloadCart();
                          } catch (err) {}
                      }
                  }
              }
          }, {
              key: "listenPushStateEvent",
              value: function() {
                  var t = this;
                  !function(t) {
                      var e = t.pushState;
                      t.pushState = function(n) {
                          return "function" == typeof t.onpushstate && t.onpushstate({
                              state: n
                          }),
                          e.apply(t, arguments)
                      }
                  }(window.history),
                  window.onpopstate = history.onpushstate = function() {
                      setTimeout(function() {
                          t.isTriggeredByState = !0,
                          t.reset(),
                          t.init()
                      }, 250)
                  }
              }
          }, {
              key: "listenSubmitsEvent",
              value: function() {
                  var t = this
                    , e = this
                    , n = window.location.href;
                  document.addEventListener("submit", function(o) {
                      if ((!document.activeElement || "update" !== document.activeElement.name) && x(o, "target.action")) {
                          var i = U(o, "target.action")
                            , a = null;
                          try {
                              a = Object.fromEntries(new FormData(o.target))
                          } catch (o) {
                              t.consoleLog(o)
                          }
                          a && t.setUser({
                              em: a["checkout[email_or_phone]"] || a["checkout[email]"],
                              ph: a["checkout[shipping_address_attributes][phone]"] || "",
                              fn: a["checkout[shipping_address][first_name]"] || a["checkout[shipping_address_attributes][first_name]"],
                              ln: a["checkout[shipping_address][last_name]"] || a["checkout[shipping_address_attributes][last_name]"],
                              ct: a["checkout[shipping_address][city]"] || a["checkout[shipping_address_attributes][city]"],
                              zp: a["checkout[shipping_address_attributes][zip]"]
                          }),
                          i.includes("/search") && e.searchEvent(a),
                          i.includes("/contact#contact_form") && e.contactEvent(a),
                          i.includes("/account") && e.signUpEvent(a),
                          i.includes("/account/login") && e.loginEvent(a),
                          i.includes("/cart/add") && (e.addToCartEvent(!0),
                          e.consoleLog("method: listenSubmitsEvent called: addToCartEvent")),
                          !i.includes("/cart/add") && (i.includes("/cart") || i.includes("/checkout") && !n.includes("/thank_you") || "/checkout" === a.return_to) && e.initiateCheckoutEvent(),
                          i.includes("/cart/add") && "/checkout" === a.return_to && e.initiateCheckoutEvent(),
                          "/cart" === o.target.getAttribute("data-zp-product-url") && e.zipifyAddToCartEvent({
                              id: o.target.getAttribute("data-productid")
                          }),
                          "contact_information" === U(window, "Shopify.Checkout.step") && e.paymentLeadEvent(),
                          "shipping_method" === U(window, "Shopify.Checkout.step") && e.addShippingInfoEvent(),
                          "payment_method" === U(window, "Shopify.Checkout.step") && e.addPaymentInfoEvent(),
                          ("step_customer_information" === O("step") || U(window, "OCUConfig") && Object.keys(a).includes("checkout[email]")) && e.paymentLeadEvent(),
                          "step_shipping_method" === O("step") && e.addShippingInfoEvent(),
                          "step_payment_method" === O("step") && e.addPaymentInfoEvent()
                      }
                  })
              }
          }, {
              key: "listenModalOpenEvent",
              value: function() {
                  var t = this
                    , e = null;
                  document.addEventListener("click", function(n) {
                      setTimeout(function() {
                          var o = this
                            , i = !1;
                          n.target.getAttribute("data-remodal-target") && (i = !0,
                          e = n.target.getAttribute("data-url")),
                          "btn quick-shop" === n.target.classList.value && (e = n.target.parentElement.parentElement.querySelector('a[href*="collections"]').href,
                          i = !0),
                          "quick_shop action_button" === n.target.classList.value && n.target.closest("a") && (e = n.target.closest("a").href,
                          i = !0),
                          n.target.classList.value.includes("t4s-svg-pr-icon") && n.target.parentElement.classList.contains("t4s-pr-quickview") && (e = n.target.parentElement.href,
                          i = !0),
                          i && e && t.getProduct(e).then(function(e) {
                              var n = JSON.parse(e);
                              t.product = n.product,
                              t.viewContentEvent()
                          }).catch(function(t) {
                              return o.consoleLog("listenModalOpenEvent", t)
                          })
                      }, 50)
                  })
              }
          }, {
              key: "listenTouchEvent",
              value: function() {
                  var t = this;
                  document.addEventListener("touchend", function(e) {
                      var n = e.target.closest("input");
                      n && "submit" === n.type && n.closest("form") && n.closest("form").action.includes("/checkout") && t.initiateCheckoutEvent()
                  })
              }
          }, {
              key: "listenDocumentClickEvent",
              value: function() {
                  var t = this;
                  document.addEventListener("click", function(e) {
                      setTimeout(function() {
                          if (x(e, "target")) {
                              //快捷购买
                              e.target.closest("button") && e.target.closest("button").classList.value.includes("product-sku__cart-submit") && theme.current_sku && (t.product = theme.current_sku,t.addToCartEvent(!0)),
                              "bookmarkit" === e.target.id && t.addToWishListEvent(),
                              e.target.closest("form") && e.target.closest("form").action.includes("/cart/add") && (e.target.closest("button") && (e.target.closest("button").classList.value.includes("action_button add_to_cart") || e.target.closest("button").classList.value.includes("ProductForm__AddToCart") || e.target.closest("button").classList.value.includes("gt_product-button") || e.target.closest("div").classList.value.includes("tee-form-action tee-form-atc-wrapper")) && (t.addToCartEvent(!0),
                              t.consoleLog("method: listenDocumentClickEvent called: addToCartEvent action: action_button add_to_cart")),
                              e.target.closest("button") && e.target.closest("button").classList.value.includes("product__add-to-cart-button add_to_cart") && (t.addToCartEvent(!0),
                              t.consoleLog("method: listenDocumentClickEvent called: addToCartEvent action: product__add-to-cart-button add_to_cart")),
                              e.target.closest("button") && e.target.closest("button").classList.value.includes("fastcheckout_buy_button") && (t.addToCartEvent(!0),
                              t.initiateCheckoutEvent(),
                              t.consoleLog("method: listenDocumentClickEvent called: initiateCheckoutEvent action: fastcheckout_buy_button")),
                              e.target.closest("button") && (e.target.closest("button").classList.value.includes("shopify_add_to_cart") || e.target.closest("button").classList.value.includes("so-btn-add-to-cart") || e.target.closest("button").classList.value.includes("btn small submit-btn")) && (t.addToCartEvent(!0),
                              t.consoleLog("method: listenDocumentClickEvent called: addToCartEvent action: shopify_add_to_cart")),
                              e.target.closest("button") && e.target.closest("button").classList.value.includes("ProductForm__AddToCart") && (t.addToCartEvent(!0),
                              t.consoleLog("method: listenDocumentClickEvent called: addToCartEvent action: ProductForm__AddToCart")),
                              e.target.closest("button") && "buttonapp" === e.target.closest("button").id && (t.addToCartEvent(!0),
                              t.consoleLog("method: listenDocumentClickEvent called: addToCartEvent action: buttonapp")),
                              e.target.closest("button") && e.target.closest("button").getAttribute("data-cart-url") && (t.addToCartEvent(!0),
                              t.consoleLog("method: listenDocumentClickEvent called: addToCartEvent action: data-cart-url")));
                              var n = e.target.closest("button");
                              if (n && n.classList.value.includes("ProductForm__AddToCart Button Button--secondary")) {
                                  t.consoleLog("method: listenDocumentClickEvent called: customhomepage");
                                  var o = n.parentElement.parentElement.parentElement.parentElement;
                                  t.consoleLog(n),
                                  t.consoleLog(o.childNodes),
                                  o.childNodes.forEach(function(e) {
                                      e.classList && e.classList.value.includes("ProductItem__Info") && e.childNodes.forEach(function(e) {
                                          e.classList && e.classList.value.includes("junip-product-rating") && t.getProductById(e.dataset.productId).then(function(e) {
                                              var n = JSON.parse(e);
                                              n.products && n.products.length && (t.product = n.products[0],
                                              t.setTagsCollections("/products/".concat(t.product.handle)),
                                              t.page != w && setTimeout(function() {
                                                  t.addToCartEvent(!0)
                                              }, 500))
                                          })
                                      })
                                  })
                              }
                              var checkoutEl = e.target.closest('button[name="checkout"], .cart-drawer__checkout-button, .cart__checkout-button, a[href*="/checkout"]');
                              checkoutEl && !(checkoutEl.href && checkoutEl.href.includes("a/secure/checkout")) && t.initiateCheckoutEvent();
                              var c = e.target.closest("button");
                              c && c.classList.value.includes("shopify-payment-button__button") && (t.addToCartEvent(!0),
                              t.initiateCheckoutEvent())
                          }
                      }, 10)
                  })
              }
          }, {
              key: "listenElementsClickEvent",
              value: function() {
                  var t = this
                    , e = this;
                  document.querySelector("ch-button button") && document.querySelector("ch-button button").addEventListener("click", function(t) {
                      e.cartHookAddPaymentInfoEvent()
                  }),
                  M(".product-form__add-button", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.consoleLog("method: listenElementsClickEvent called: addToCartEvent action: .product-form__add-button")
                      })
                  }),
                  M('button[data-action="add-to-cart"]', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.consoleLog('method: listenElementsClickEvent called: addToCartEvent action: button[data-action="add-to-cart"]')
                      })
                  }),
                  e.loadtimes > 0 && setTimeout(function() {
                      M(".ProductForm__AddToCart", 5, function(t) {
                          t && R(t, "click mousedown touch", function() {
                              e.addToCartEvent()
                          })
                      }),
                      M(".Cart__Footer", 5, function(t) {
                          t && R(t, "click mousedown touch", function() {
                              e.initiateCheckoutEvent()
                          })
                      }),
                      e.listenElementsClickEvent(),
                      e.loadtimes--
                  }, 500),
                  setTimeout(function() {
                      s(document.querySelectorAll("span")).filter(function(t) {
                          return t.innerHTML.trim().toLowerCase().includes("shoppay")
                      }).forEach(function(t) {
                          var n = t.closest("div[role=button]");
                          n && R(n, "click mousedown touch", function() {
                              e.initiateCheckoutEvent()
                          })
                      })
                  }, 1e3),
                  M(".checkout-button.button", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M("form[action='/cart'] [name='checkout']", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M("form[action='/cart?locale=en'] [name='checkout']", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('a[href="/checkout"]', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M("button[data-opc-dyn-c-btn-id]", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.initiateCheckoutEvent(),
                          e.consoleLog("method: listenElementsClickEvent called: addToCartEvent action: button[data-opc-dyn-c-btn-id]")
                      })
                  }),
                  M(".hs-checkout-purchase", 5, function(n) {
                      n && R(n, "click mousedown touch", function() {
                          t.consoleLog("TFX Fired Event"),
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M(".quick-cart__buy-now", 5, function(n) {
                      n && R(n, "click mousedown touch", function() {
                          t.consoleLog("TFX Fired Event"),
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M(".satcb-cs-checkout-btn", 5, function(n) {
                      n && R(n, "click mousedown touch", function() {
                          t.consoleLog("TFX Fired Event"),
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="buy"]', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.initiateCheckoutEvent(),
                          e.consoleLog('method: listenElementsClickEvent called: addToCartEvent action: button[name="buy"]')
                      })
                  }),
                  M("button[data-testid]", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.initiateCheckoutEvent(),
                          e.consoleLog("method: listenElementsClickEvent called: addToCartEvent action: button[data-testid]")
                      })
                  }),
                  M('input[value="Check out"]', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.initiateCheckoutEvent(),
                          e.consoleLog('method: listenElementsClickEvent called: addToCartEvent action: input[value="Check out"]')
                      })
                  }),
                  M('.cart_container button[type="submit"].action_button.add_to_cart', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.consoleLog('method: listenElementsClickEvent called: addToCartEvent action: .cart_container button[type="submit"].action_button.add_to_cart')
                      })
                  }),
                  M('button[name="add"].action_button.add_to_cart', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0),
                          e.consoleLog('method: listenElementsClickEvent called: addToCartEvent action: button[name="add"].action_button.add_to_cart')
                      })
                  }),
                  M('button[type="submit"].Cart__Checkout', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="checkout"].checkout_btn', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="checkout"].btn--primary', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="checkout"].checkout', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="checkout"].cart__checkout-button', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="checkout"].action_button.add_to_cart', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M(".slidecarthq .footer-buttons button.button.full", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M(".grid__item .right.Checkout", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M(".actions button.btn[onclick]", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M(".rebuy-cart__flyout-actions button.rebuy-button", 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="checkout"].cart__checkout', 5, function(t) {
                      t && R(t, "click mousedown mouseup touch", function() {
                          e.initiateCheckoutEvent()
                      })
                  }),
                  M('button[name="add"].gt_product-button', 5, function(t) {
                      t && R(t, "click mousedown touch", function() {
                          e.addToCartEvent(!0)
                      })
                  }),
                  M('button[name="add"].bttn.product-price', 5, function(n) {
                      n && R(n, "click mousedown touch", function() {
                          var n = !1
                            , o = document.querySelectorAll("form[action='/cart/add']");
                          if (o.length > 0 && e.page != C) {
                              var i = o[0].getAttribute("id");
                              e.consoleLog("Incart Product Form detected, product id is ".concat(i)),
                              i && (i = (i = i.replace("product-actions-", "")).replace("upsell_product_form_", ""),
                              e.consoleLog("Incart Cleared Product ID is: ".concat(parseInt(i))),
                              parseInt(i) && my_offers.forEach(function(o) {
                                  t.consoleLog(o, "incart offer"),
                                  (o.id === parseInt(i) || o.offerable_product_shopify_ids.includes(parseInt(i))) && (e.consoleLog("incart offer product"),
                                  n = o.checkout_after_accepted)
                              }))
                          }
                          n && (e.consoleLog("Inside redirectToCheckout"),
                          e.isFetchingCart = !0,
                          N("".concat(e.shopHost, "/cart.json")).then(function(t) {
                              var n = JSON.parse(t);
                              e.isFetchingCart = !1,
                              n && (e.cart = n,
                              localStorage.setItem("TFX_CART", JSON.stringify(n)),
                              setTimeout(function() {
                                  e.initiateCheckoutEvent()
                              }, 1e3))
                          }).catch(function(n) {
                              t.consoleLog(n),
                              e.isFetchingCart = !1
                          })),
                          e.consoleLog('method: listenElementsClickEvent Test called: InitiateCheckoutEvent action: button[name="add"].action_button.add_to_cart')
                      })
                  }),
                  B(".bettercart_checkout", 5, function(n) {
                      n.length > 0 && (t.isBetterCart = !0,
                      n.forEach(function(n) {
                          R(n, "click mousedown touch", function() {
                              t.consoleLog("GBTC_IC"),
                              e.initiateCheckoutEvent()
                          })
                      }))
                  }),
                  B(".shopify-payment-button .bettercart_checkout", 5, function(t) {
                      t.forEach(function(t) {
                          t && R(t, "click mousedown touch", function() {
                              e.addToCartEvent(!0),
                              e.initiateCheckoutEvent(),
                              e.consoleLog("method: listenElementsClickEvent called: addToCartEvent action: .shopify-payment-button .bettercart_checkout.bettercart_checkout")
                          })
                      })
                  }),
                  M(".text-center.uppercase.cursor-pointer", 5, function(n) {
                      "BetterCartCheckoutOffer" == t.page && n && R(n, "click mousedown touch", function() {
                          e.addToCartEvent(!0)
                      })
                  }),
                  B('button[data-pf-type="ProductATC"]', 5, function(n) {
                      n.forEach(function(n) {
                          n && R(n, "click touch", function() {
                              parseInt(n.getAttribute("data-product-id")) && (t.isLoadingProduct = !0,
                              t.getProductById(n.getAttribute("data-product-id")).then(function(o) {
                                  var i = JSON.parse(o);
                                  i.products && i.products.length && (t.product = i.products[0],
                                  t.setTagsCollections("/products/".concat(t.product.handle)),
                                  t.isLoadingProduct = !1),
                                  t.isLoadingProduct = !1,
                                  e.addToCartEvent(!0),
                                  n.getAttribute("data-checkout") && "checkout" == n.getAttribute("data-checkout") && e.initiateCheckoutEvent()
                              }).catch(function(e) {
                                  t.isLoadingProduct = !1,
                                  t.consoleLog("loadProduct", e)
                              }))
                          })
                      })
                  }),
                  this.page != C || this.iscategoryswatchloaded || (this.iscategoryswatchloaded = 1,
                  B(".shopify-product-form.custome-product-form .swatch-element", 5, function(n) {
                      n && n.forEach(function(n) {
                          R(n, "click touch", function() {
                              var o = n.closest("form[action='/cart/add']")
                                , i = o.querySelector('input[name="id"]')
                                , a = o.getAttribute("id");
                              t.consoleLog("Product Form detected, product id is ".concat(a)),
                              i && i.getAttribute("data-productid") && (a = i.getAttribute("data-productid")),
                              a && (a = (a = (a = (a = (a = (a = a.replace("product_form_", "")).replace("upsell_product_form_", "")).replace("product-form-", "")).replace("product-template", "")).replace("AddToCartForm--", "")).replace("js--", ""),
                              e.consoleLog("Cleared Product ID is: ".concat(parseInt(a))),
                              parseInt(a) && (e.isLoadingProduct = !0,
                              e.getProductById(a).then(function(t) {
                                  var n = JSON.parse(t);
                                  n.products && n.products.length && (e.product = n.products[0],
                                  e.setTagsCollections("/products/".concat(e.product.handle)),
                                  e.addToCartEvent(!0)),
                                  e.isLoadingProduct = !1
                              }).catch(function(t) {
                                  e.isLoadingProduct = !1,
                                  e.consoleLog("loadProduct", t)
                              })))
                          })
                      })
                  })),
                  B("a.shg-btn.shg-cse", 5, function(n) {
                      n.forEach(function(n) {
                          n && R(n, "click touch", function() {
                              var o = n.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('[data-shg-product-target="product-title"]').innerHTML
                                , i = null;
                              for (var a in window.__shgProducts)
                                  window.__shgProducts[a].title === o && (i = window.__shgProducts[a].id);
                              i && (t.isLoadingProduct = !0,
                              t.loadProduct(),
                              console.log("a.shg-btn.shg-cse")
                              // t.getProductById(i).then(function(n) {
                              //     var o = JSON.parse(n);
                              //     o.products && o.products.length && (t.product = o.products[0],
                              //     t.setTagsCollections("/products/".concat(t.product.handle)),
                              //     t.isLoadingProduct = !1),
                              //     t.isLoadingProduct = !1,
                              //     e.addToCartEvent(!0)
                              // }).catch(function(e) {
                              //     t.isLoadingProduct = !1,
                              //     t.consoleLog("loadProduct", e)
                              // })
                              )
                          })
                      })
                  })
              }
          }, {
              key: "listenFormChangeEvent",
              value: function() {
                  var t = this
                    , e = this;
                  document.addEventListener("change", function(n) {
                      if (n.target.closest("form"))
                          try {
                              var o = Object.fromEntries(new FormData(n.target.closest("form")))
                                , i = U(n, "target.form.action");
                              (i.includes("/cart/add") || i.includes("/secure-checkout/offers/")) && e.customizeProductEvent(o)
                          } catch (n) {
                              t.consoleLog(n)
                          }
                  })
              }
          }, {
              key: "listenBlurEvent",
              value: function(t) {
                  var e = this
                    , n = this
                    , o = document.querySelectorAll(['customer-fieldset input[name="email"]'].join(","));
                  o.length ? o.forEach(function(t) {
                      t.addEventListener("blur", function(t) {
                          n.paymentLeadEvent(),
                          n.setUser({
                              em: t.target.value
                          })
                      })
                  }) : t > 0 && setTimeout(function() {
                      e.listenBlurEvent(--t)
                  }, 400)
              }
          }, {
              key: "pageViewEvent",
              value: function(t) {
                  var e = !0;
                  this.isIOS14 && !this.pageViewEventFire && (this.consoleLog("IOS14: Page View Event Restricted"),
                  e = !1),
                  this.fire(g, e, null, !1, t)
              }
          }, {
              key: "viewCategoryEvent",
              value: function() {
                  var t = this.collections.join(",")
                    , e = {
                      content_name: "Collection [ ".concat(t, " ]")
                  }
                    , n = !0;
                  this.isIOS14 && !this.viewCategoryEventFire && (this.consoleLog("IOS14: View Category Event Restricted"),
                  n = !1),
                  this.fire("ViewCategory", n, e, !0)
              }
          }, {
              key: "viewContentEvent",
              value: function(t) {
                  var e = t || f
                    , n = !0;
                  this.isIOS14 && !this.viewContentEventFire && (this.consoleLog("IOS14: View Content Event Restricted"),
                  n = !1),
                  !this.product || this.isPageFlyPage || this.isShogunPage || this.fire(f, n, this.getProductData(e, this.product))
              }
          }, {
              key: "customizeProductEvent",
              value: function() {
                  var t = this.getProductData("CustomizeProduct", this.product)
                    , e = !0;
                  this.isIOS14 && !this.customizeProductEventFire && (this.consoleLog("IOS14: Customize Product Event Restricted"),
                  e = !1),
                  this.fire("CustomizeProduct", e, t)
              }
          }, {
              key: "addToCartEvent",
              value: function(t) {
                  var e = this;
                  if ((!t || this.shop.atc_click) && !this.isAddingToCart) {
                      this.isAddingToCart = !0;
                      var n = !0;
                      if (this.isIOS14 && !this.addToCartEventFire && (this.consoleLog("IOS14: Add To Cart Event Restricted"),
                      n = !1),
                      this.product) {
                          var o = this.getProductData(v, this.product);
                          this.fire(v, n, o),
                          this.addToCart(this.product),
                          this.saveCartProduct(this.product.handle),
                          setTimeout(function() {
                              e.isAddingToCart = !1,
                              e.reloadCart(),
                              e.setTagsCollections("/cart"),
                              e.isPageFlyPage || e.isShogunPage || e.listenElementsClickEvent()
                          }, 2e3)
                      } else
                          this.isAddingToCart = !1
                  }
              }
          }, {
              key: "viewCartEvent",
              value: function() {
                  var t = this.getCartProductsData("ViewCart")
                    , e = !0;
                  this.isIOS14 && !this.viewCartEventFire && (this.consoleLog("IOS14: View Cart Event Restricted"),
                  e = !1),
                  this.fire("ViewCart", e, t, !0)
              }
          }, {
              key: "initiateCheckoutEvent",
              value: function(t) {
                  this.consoleLog("Initiate Checkout Event");
                  var e = !0;
                  if (this.isIOS14 && !this.initiateCheckoutEventFire && (this.consoleLog("IOS14: Initiate Checkout Event Restricted"),
                  e = !1),
                  // 10分钟之后过期
                  !F("TFX_IC") && this.shop.ic_switch) {
                      I("TFX_IC", !0, {
                          "max-age": 600
                      });
                      this.fire(y, e, this.getCartProductsData(y, t)),
                      this.consoleLog("Other: Initiate Checkout Event Fired")
                  }
              }
          }, {
              key: "paymentLeadEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.addPaymentLeadEventFire && (this.consoleLog("IOS14: Payment Lead Event Restricted"),
                  t = !1),
                  F("TFX_LEAD") || (I("TFX_LEAD", !0, {
                      "max-age": 200
                  }),
                  this.fire("Lead", t, this.getCartProductsData("Lead")),
                  this.consoleLog("Other: Payment Lead Event Fired"))
              }
          }, {
              key: "addShippingInfoEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.addShippingInfoEventFire && (this.consoleLog("IOS14: Add Shipping Info Event Restricted"),
                  t = !1);
                  var e = this.getCartProductsData("AddShippingInfo");
                  this.fire("AddShippingInfo", t, e, !0),
                  this.consoleLog("Other: Add Shipping Info Event Fired")
              }
          }, {
              key: "addPaymentInfoEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.addPaymentInfoEventFire && (this.consoleLog("IOS14: Add Payment Info Event Restricted"),
                  t = !1);
                  var e = this.getCartProductsData("AddPaymentInfo");
                  this.fire("AddPaymentInfo", t, e, !0),
                  this.consoleLog("Other: Add Payment Info Event Fired")
              }
          }, {
              key: "purchaseEvent",
              value: function(t, e) {
                  var n = !0;
                  this.isIOS14 && !this.purchaseEventFire && (this.consoleLog("IOS14: Purchase Event Restricted"),
                  n = !1);
                  var o = this
                    , i = o.getPurchaseData(t, e);
                  // this.clearArray(this.tags).length && this.clearArray(this.collections).length && this.page !== P || t && (i = t.map(function(t) {
                  //     return t.product_id
                  // }).filter(function(t) {
                  //     return !!t
                  // })),
                  o.fire(m, n, i),
                  A("TFX_IC"),
                  A("TFX_LEAD"),
                  A("TFX_ATC")
                  // this.setTagsAndCollectionsFromBackend(i).then(function() {
                  //     var i = o.getPurchaseData(t, e);
                  //     if ((o.consoleLog("PURCHASE EVENT DATA", JSON.stringify(i)),
                  //     o.checkout) && Math.floor(((new Date).getTime() - new Date(o.checkout.updated_at).getTime()) / 1e3 / 60) > 10)
                  //         return void o.consoleLog("Event not triggered because order created at more then 10 minutes ago");
                  //     o.fire(m, n, i),
                  //     A("TFX_IC"),
                  //     A("TFX_LEAD"),
                  //     A("TFX_ATC")
                  // }).catch(this.consoleLog)
              }
          }, {
              key: "addToWishListEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.addToWishlistEventFire && (this.consoleLog("IOS14: Add To Wish List Event Restricted"),
                  t = !1);
                  var e = this.getProductData(f, this.product);
                  this.fire("AddToWishlist", t, e)
              }
          }, {
              key: "searchEvent",
              value: function(t) {
                  var e = !0;
                  this.isIOS14 && !this.searchEventFire && (this.consoleLog("IOS14: Search Event Restricted"),
                  e = !1);
                  var n = {
                      currency: this.shop.currency,
                      search_string: t.q,
                      value: 0
                  };
                  this.fire("Search", e, n)
              }
          }, {
              key: "contactEvent",
              value: function(t) {
                  var e = !0;
                  this.isIOS14 && !this.contactEventFire && (this.consoleLog("IOS14: Contact Event Restricted"),
                  e = !1),
                  this.setUser({
                      fn: t["contact[first_name]"],
                      ln: t["contact[last_name]"],
                      em: t["contact[email]"]
                  }),
                  this.fire("Contact", e, {})
              }
          }, {
              key: "signUpEvent",
              value: function(t) {
                  this.setUser({
                      fn: t["customer[first_name]"],
                      ln: t["customer[last_name]"],
                      em: t["customer[email]"]
                  })
              }
          }, {
              key: "loginEvent",
              value: function(t) {
                  this.setUser({
                      em: t["customer[email]"]
                  })
              }
          }, {
              key: "timerEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.timerEventFire && (this.consoleLog("IOS14: Timer Event Restricted"),
                  t = !1);
                  var e = this.getTimerData();
                  this.fire(_, t, e, !0)
              }
          }, {
              key: "setZipifyTagsCollections",
              value: function() {
                  var t = this;
                  if (!x(window, "productJSON"))
                      return {};
                  var e = this;
                  this.collections = [],
                  this.tags = [],
                  this.isZipifyTagsCollectionsLoaded = !0,
                  this.isLogingZipifyTagsCollections = !0,
                  setTimeout(function() {
                      t.isZipifyTagsCollectionsLoaded = !1
                  }, 1200);
                  var n = window.productJSON.map(function(e) {
                      return new Promise(function(n) {
                          t.getTagsCollections("/products/".concat(e.handle)).then(function(t) {
                              n({
                                  product_id: e.id,
                                  html: t
                              })
                          }).catch(t.consoleLog)
                      }
                      )
                  });
                  Promise.all(n).then(function(n) {
                      n.forEach(function(n) {
                          var o = t.extractTagsCollections(n.html);
                          t.collections = t.collections.concat(o.collections),
                          t.tags = t.tags.concat(o.tags),
                          e.tags = s(new Set(e.tags)),
                          e.collections = s(new Set(e.collections)),
                          e.shop && (e.filterPixels(),
                          e.initPixels()),
                          t.zipifyProductsTagsCollections.push({
                              product_id: n.product_id,
                              tags: o.tags,
                              collections: o.collections
                          }),
                          t.isLogingZipifyTagsCollections = !1
                      })
                  }).catch(function(e) {
                      t.consoleLog(e),
                      t.isLogingZipifyTagsCollections = !1
                  })
              }
          }, {
              key: "getZipifyProductsData",
              value: function() {
                  var t = this;
                  if (!x(window, "productJSON"))
                      return null;
                  var e = window.productJSON;
                  return {
                      content_name: "Trackify PG ViewContent: ".concat(this.printTags()),
                      content_type: this.shop.report_variants && product.variants.length ? "product" : "product_group",
                      content_ids: e.map(function(e) {
                          return t.shop.report_variants ? t.getVariant(e).id : e.id
                      }),
                      content_category: s(new Set(e.map(function(t) {
                          return t.type
                      }))).join(", "),
                      content_timedata: D(),
                      content_collections: this.printCollections(),
                      value: this.shop.value_reporting ? this.calculatePrice(e.reduce(function(t, e) {
                          return t + e.price
                      }, 0)) : 0,
                      currency: U(window, "ShopifyAnalytics.meta.currency") || this.cart.currency,
                      contents: e.map(function(e) {
                          return {
                              id: t.shop.report_variants ? t.getVariant(e).id : e.id,
                              name: e.title,
                              quantity: 1,
                              item_price: t.calculatePrice(e.price),
                              item_category: e.type
                          }
                      }),
                      num_items: e.length
                  }
              }
          }, {
              key: "zipifyViewContentEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.viewContentEventFire && (this.consoleLog("IOS14: Zipify View Content Event Restricted"),
                  t = !1);
                  var e = this;
                  if (this.isLogingZipifyTagsCollections)
                      setTimeout(function() {
                          e.zipifyViewContentEvent()
                      }, 500);
                  else {
                      var n = this.getZipifyProductsData();
                      n && !(U(window, "ZipifyPages.analytics.disabled_events.trackify") || []).length && this.fire(f, t, n),
                      this.consoleLog("Other: Zipify View Content Event Fired")
                  }
              }
          }, {
              key: "zipifyAddToCartEvent",
              value: function(t) {
                  var e = this;
                  if (x(window, "productJSON"))
                      if (this.isLogingZipifyTagsCollections)
                          setTimeout(function() {
                              e.zipifyAddToCartEvent()
                          }, 500);
                      else {
                          var n = window.productJSON.find(function(e) {
                              return e.id === parseInt(t.id) || e.variants.find(function(e) {
                                  return e.id === parseInt(t.id)
                              })
                          });
                          if (n) {
                              var o = this.zipifyProductsTagsCollections.find(function(t) {
                                  return t.product_id === n.id
                              });
                              o && (this.tags = o.tags,
                              this.collections = o.collections),
                              this.product = n,
                              this.addToCartEvent()
                          }
                          this.consoleLog("Other: Zipify Add To Cart Event Fired")
                      }
              }
          }, {
              key: "ShogunViewContentEvent",
              value: function() {
                  var t = !0;
                  if (this.isIOS14 && !this.viewContentEventFire && (this.consoleLog("IOS14: Shogun View Content Event Restricted"),
                  t = !1),
                  this.product) {
                      var e = this.getProductData(f, this.product);
                      this.fire(f, t, e)
                  } else
                      this.consoleLog("Other: Shogun View Content Event Fired")
              }
          }, {
              key: "getOCUProduct",
              value: function() {
                  this.product = U(window, "OCUConfig.product")
              }
          }, {
              key: "getOcuPurchaseData",
              value: function(t, e) {
                  var n = this;
                  if (!x(window, "OCUConfig.trackify.transactions"))
                      return {};
                  var o = this
                    , i = []
                    , a = []
                    , r = []
                    , c = 0
                    , u = [];
                  return window.OCUConfig.trackify.transactions.forEach(function(t) {
                      e ? -1 !== ["completed", "bought", "thank_you_page"].indexOf(t.status) && t.items.length && (u = u.concat(t.items),
                      c += parseFloat(t.total_amount)) : ("completed" === t.status && t.items.length && (u = t.items,
                      c = t.total_amount),
                      "bought" === t.status && t.items.length && (u = t.items,
                      c = t.total_amount),
                      "thank_you_page" === t.status && t.items.length && (u = t.items,
                      c = t.total_amount))
                  }),
                  u.forEach(function(t) {
                      r.push(t.product.product_type),
                      a.push(n.shop.report_variants ? t.shopify_variant_id : t.shopify_product_id),
                      i.push({
                          id: o.shop.report_variants ? t.shopify_variant_id : t.shopify_product_id,
                          name: t.variant_title || t.title,
                          quantity: t.quantity,
                          currency: n.shop.currency,
                          item_price: o.calculatePrice(t.price, !0),
                          item_category: t.product ? t.product.product_type : ""
                      })
                  }),
                  {
                      content_name: "Trackify OCU ".concat(t, ": ").concat(this.printTags()),
                      content_type: this.shop.report_variants ? "product" : "product_group",
                      content_ids: a,
                      content_category: s(new Set(r)).join(", "),
                      content_timedata: D(),
                      content_collections: this.printCollections(),
                      value: this.calculatePrice(c || 0, !0),
                      currency: this.shop.currency || "USD",
                      contents: i,
                      num_items: (window.OCUConfig.trackify.transactions[0].items || []).length,
                      discount: U(this, "checkout.discount.brand") || 0,
                      order_id: U(window, "OCUConfig.trackify.shopify_order_id"),
                      content_pmtmethod: "OCU_".concat(U(window, "OCUConfig.trackify.payment_method") || "other")
                  }
              }
          }, {
              key: "getOcuPurchaseEventName",
              value: function() {
                  var t = null
                    , e = null
                    , n = null
                    , o = !1;
                  return window.OCUConfig.trackify.transactions.forEach(function(i) {
                      if ("completed" !== i.status || F("TFX_OCU_".concat(i.name)) || (e = "TFX_OCU_".concat(i.name),
                      t = {
                          name: "InitialPurchase",
                          cookie: e,
                          price: i.total_amount
                      },
                      I(e, !0, {
                          "max-age": 600
                      })),
                      "bought" === i.status && !F("TFX_OCU_".concat(i.name))) {
                          e = "TFX_OCU_".concat(i.name);
                          t = {
                              name: "".concat(i.name.replace(/[a-zA-Z]/g, "")).concat(i.name.replace(/[0-9]/g, ""), "Purchase"),
                              cookie: e,
                              price: i.total_amount
                          };
                          I(e, !0, {
                              "max-age": 600
                          })
                      }
                      "thank_you_page" !== i.status || F("TFX_OCU_Purchase") || (n = {
                          name: "Purchase",
                          cookie: e = "TFX_OCU_Purchase",
                          price: i.total_amount
                      },
                      I(e, !0, {
                          "max-age": 600
                      })),
                      !o && i.name.indexOf("Upsell") > -1 && (o = !0)
                  }),
                  !o && n && (t = n),
                  t
              }
          }, {
              key: "ocuClearCookies",
              value: function() {
                  document.cookie.split(";").map(function(t) {
                      return t.split("=")[0]
                  }).filter(function(t) {
                      return t.includes("TFX_OCU_")
                  }).forEach(function(t) {
                      A(t.trim())
                  })
              }
          }, {
              key: "ocuPurchaseEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.purchaseEventFire && (this.consoleLog("IOS14: OCU Purchase Event Restricted"),
                  t = !1);
                  var e = this.getOcuPurchaseEventName();
                  if (this.consoleLog(e),
                  "OCUThankYou" === this.page) {
                      if (F("TFX_ORDER_OCU_".concat(U(window, "OCUConfig.trackify.shopify_order_id"))))
                          return;
                      if (I("TFX_ORDER_OCU_".concat(U(window, "OCUConfig.trackify.shopify_order_id")), 1, {
                          "max-age": 600
                      }),
                      e) {
                          var n = this.getOcuPurchaseData(e.name);
                          this.shop.ocu_ss_api ? (this.fire(e.name.replace("TFX_OCU_", ""), t, n, !0),
                          n = this.getOcuPurchaseData(e.name, !0),
                          this.fire(m, t, n)) : this.fire(m, t, n, !1, null, !0)
                      }
                  } else {
                      if (!e)
                          return;
                      var o = this.getOcuPurchaseData(e.name);
                      this.shop.ocu_ss_api ? this.fire(e.name.replace("TFX_OCU_", ""), t, o, !0) : this.fire(m, t, o)
                  }
                  A("TFX_IC"),
                  A("TFX_LEAD"),
                  this.consoleLog("Other: OCU Purchase Event Fired")
              }
          }, {
              key: "ocuViewContentEvent",
              value: function() {
                  var t = !0;
                  this.isIOS14 && !this.viewContentEventFire && (this.consoleLog("IOS14: OUC View Content Event Restricted"),
                  t = !1);
                  var e, n, o, i = window.OCUConfig.trackify.transactions.filter(function(t) {
                      return "declined" === t.status
                  }).length, a = window.OCUConfig.trackify.transactions.filter(function(t) {
                      return -1 !== ["bought", "offered"].indexOf(t.status)
                  }).length, r = "DownsellViewContent";
                  i || (n = ["zeroth", "first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "ninth", "tenth", "eleventh", "twelfth", "thirteenth", "fourteenth", "fifteenth", "sixteenth", "seventeenth", "eighteenth", "nineteenth"],
                  o = ["twent", "thirt", "fort", "fift", "sixt", "sevent", "eight", "ninet"],
                  r = ((e = a) < 20 ? q(n[e]) : e % 10 == 0 ? q(o[Math.floor(e / 10) - 2] + "ieth") : q(o[Math.floor(e / 10) - 2]) + "y" + q(n[e % 10])) + "UpsellViewContent"),
                  this.viewContentEvent(r, t),
                  this.consoleLog("Other: OUC View Content Event Fired")
              }
          }, {
              key: "getProductsFromBackend",
              value: function(t, e) {
                  var n = this
                    , o = this;
                  return new Promise(function(i, a) {
                      console.log('getProductsFromBackend');
                      // N("".concat(n.backendURL, "/get/").concat(n.shopName, "/products?ids=") + t.map(function(t) {
                      //     return t.id
                      // }).join(",")).then(function(r) {
                      //     var c = JSON.parse(r);
                      //     if (c.products && c.products.length) {
                      //         var u = c.products.map(function(e) {
                      //             var n = t.find(function(t) {
                      //                 return t.id === e.id
                      //             }) || {};
                      //             return d({}, e, {}, n)
                      //         });
                      //         o.setCart({
                      //             items: u,
                      //             original_total_price: e.original_total_price,
                      //             currency: e.currency,
                      //             total_discount: e.discount
                      //         });
                      //         var l = c.products.map(function(t) {
                      //             return new Promise(function(e, i) {
                      //                 n.getTagsCollections("".concat(n.shopHost, "/products/").concat(t.handle)).then(function(i) {
                      //                     var a = n.extractTagsCollections(i);
                      //                     o.collections = o.collections.concat(a.collections),
                      //                     o.tags = o.tags.concat(a.tags),
                      //                     e({
                      //                         product_id: t.id,
                      //                         html: i
                      //                     })
                      //                 }).catch(function(t) {
                      //                     i(t)
                      //                 })
                      //             }
                      //             )
                      //         });
                      //         Promise.all(l).then(function() {
                      //             o.tags = s(new Set(o.tags)),
                      //             o.collections = s(new Set(o.collections)),
                      //             o.filterPixels(),
                      //             o.initPixels(),
                      //             i({
                      //                 items: u
                      //             })
                      //         }).catch(function(t) {
                      //             i({
                      //                 items: u
                      //             })
                      //         })
                      //     } else
                      //         a("No products fetched...")
                      // }).catch(a)
                      }
                  )
              }
          }, {
              key: "listenInterCartEvents",
              value: function(t) {
                  var e = this
                    , n = this
                    , o = [];
                  this.consoleLog("Intercart", t),
                  t.forEach(function(t) {
                      if (-1 === n.interCartEvents.indexOf(t.type)) {
                          n.interCartEvents.push(t.type),
                          n.interCartEvent = t;
                          var i = {
                              original_total_price: U(t, "additional.total"),
                              currency: U(t, "additional.currency"),
                              total_discount: U(t, "additional.discount")
                          };
                          switch (x(t, "payload.content_ids") && (o = U(t, "payload.content_ids").map(function(t) {
                              return {
                                  id: parseInt(t)
                              }
                          })),
                          x(t, "additional.items") && U(t, "additional.items").forEach(function(t, e) {
                              o[e] && (o[e].quantity = parseInt(t.quantity) || 1,
                              o[e].line_price = t.price || 0,
                              o[e].price = t.price || 0)
                          }),
                          t.type) {
                          case "initialize":
                              n.shopName = U(t, "payload.shop"),
                              n.shopHost = U(t, "payload.origin"),
                              n.setUser({
                                  external_id: U(t, "payload.session_id")
                              });
                              break;
                          case "InitiateCheckout":
                              console.log('==InitiateCheckout==');
                              // n.getProductsFromBackend(o, i).then(function() {
                              //     n.initiateCheckoutEvent(!0)
                              // }).catch(e.consoleLog);
                              break;
                          case "AddPaymentInfo":
                              e.setCart(i),
                              e.addPaymentInfoEvent();
                              break;
                          case "Purchase":
                          case "PostPurchase":
                              console.log('Purchase===PostPurchase');
                              // n.getProductsFromBackend(o, i).then(function(e) {
                              //     n.purchaseEvent(e.items, t.type)
                              // }).catch(e.consoleLog)
                          }
                      }
                  })
              }
          }, {
              key: "cartHookAddPaymentInfoEvent",
              value: function() {
                  if (x(window, "carthook_object.cart_data")) {
                      U(window, "carthook_object.cart_data");
                      this.addPaymentInfoEvent()
                  }
              }
          }, {
              key: "cartHookInitiateCheckoutEvent",
              value: function() {
                  if (x(window, "carthook_object.cart_data")) {
                      var t = this
                        , e = U(window, "carthook_object.cart_data")
                        , n = e.line_items.map(function(t) {
                          return {
                              id: parseInt(t.id),
                              quantity: parseInt(t.quantity) || 1,
                              variant_id: parseInt(t.variant_id),
                              line_price: t.line_price,
                              price: t.line_price
                          }
                      })
                        , o = {
                          original_total_price: e.total_price,
                          currency: e.currency || "USD",
                          total_discount: e.coupon
                      };
                      console.log('cartHookInitiateCheckoutEvent');
                      // this.getProductsFromBackend(n, o).then(function() {
                      //     t.initiateCheckoutEvent()
                      // }).catch(this.consoleLog)
                  }
              }
          }, {
              key: "getCartHookPurchaseEventName",
              value: function() {
                  var t = U(window, "chData");
                  return t ? "checkout_page" === t.last_charged_page_type ? "TFX_CH_InitialPurchase" : "upsell_page" === t.last_charged_page_type ? "TFX_CH_UpsellPurchase" : "downsell_page" === t.last_charged_page_type ? "TFX_CH_DownsellPurchase" : void 0 : ""
              }
          }, {
              key: "cartHookPurchaseEvent",
              value: function(t) {
                  if (U(window, "chData.last_charged_page_type")) {
                      var e = this
                        , n = (F("TFX_PURCHASED"),
                      U(window, "chData.order"))
                        , o = this.getCartHookPurchaseEventName()
                        , i = []
                        , a = n.last_charged_line_items.map(function(t) {
                          return {
                              id: parseInt(t.id),
                              quantity: parseInt(t.quantity) || 1,
                              variant_id: parseInt(t.variant_id),
                              line_price: t.price,
                              price: t.price
                          }
                      }).filter(function(e) {
                          return -1 === i.indexOf("".concat(e.id, ":").concat(t))
                      });
                      console.log('cartHookPurchaseEvent');
                      if (a.length) {
                          var r = {
                              original_total_price: "TFX_CH_InitialPurchase" == o ? U(window, "chData.order.total_price") : a.reduce(function(t, e) {
                                  return t + e.line_price * e.quantity
                              }, 0),
                              currency: n.currency || "USD",
                              total_discount: n.coupon
                          };
                          // this.getProductsFromBackend(a, r).then(function(n) {
                          //     var a = n.items.map(function(e) {
                          //         return "".concat(e.id, ":").concat(t)
                          //     });
                          //     I("TFX_PURCHASED", [].concat(i, s(a)).join(","), {
                          //         "max-age": 200
                          //     }),
                          //     e.purchaseEvent(n.items, o)
                          // }).catch(this.consoleLog)
                      } else
                          this.consoleLog("No Products, Check TFX_PURCHASED")
                  }
              }
          }, {
              key: "cartHookViewContentEvent",
              value: function() {
                  var t = this
                    , e = U(window, "carthook_object.product") || (U(window, "carthook_object.cart_data.line_items") || [])[0];
                  e && this.getTagsCollections("/products/".concat(e.handle)).then(function(n) {
                      var o = t.extractTagsCollections(n);
                      t.getProduct("/products/".concat(e.handle)).then(function(n) {
                          t.tags = o.tags,
                          t.collections = o.collections,
                          localStorage.setItem("tags", t.tags.join(", ")),
                          localStorage.setItem("collections", t.collections.join(", ")),
                          t.product = JSON.parse(n).product,
                          t.product.price = e.line_price,
                          t.product.variants && t.product.variants.length && (t.product.variants[0].price = e.line_price),
                          t.viewContentEvent()
                      })
                  }).catch(this.consoleLog)
              }
          }, {
              key: "listenShopiPayEvents",
              value: function(t) {
                  switch (this.consoleLog("SHOPIPAY EVENT", JSON.stringify(t)),
                  this.consoleLog("SHOPIPAY DATA LOADED", this.shop),
                  t.type) {
                  case "Initialize":
                      this.consoleLog("ShopiPay Init...");
                      break;
                  case y:
                      this.shopiPayInitiateCheckoutEvent(t);
                      break;
                  case m:
                  case "PostPurchase":
                      this.shopiPayPurchaseEvent(t);
                      break;
                  case f:
                      this.shopiPayViewContentEvent(t)
                  }
              }
          }, {
              key: "shopiPayInitiateCheckoutEvent",
              value: function(t) {
                  var e = this
                    , n = t.products.map(function(t) {
                      return {
                          id: t.product_id
                      }
                  });
                  console.log('shopiPayInitiateCheckoutEvent');
                  // this.getProductsFromBackend(n, this.cart).then(function() {
                  //     e.initiateCheckoutEvent()
                  // }).catch(console.log)
              }
          }, {
              key: "shopiPayPurchaseEvent",
              value: function(t) {
                  var e = [];
                  t.products.forEach(function(t) {
                      t.product_id ? e.push(t) : t.id && (t.product_id = t.id,
                      e.push(t))
                  }),
                  t.upsellStep && t.accept ? this.purchaseEvent(e, "TFX_SHP_" + t.upsellStep + " Purchase") : this.purchaseEvent(e, "TFX_SHP_Initial Purchase")
              }
          }, {
              key: "shopiPayViewContentEvent",
              value: function(t) {
                  var e = !0;
                  this.isIOS14 && !this.viewContentEventFire && (this.consoleLog("IOS14: ShopiPay View Content Event Restricted"),
                  e = !1);
                  var n = this;
                  t.products.forEach(function(t) {
                      return n.fire(f, e, n.getProductData(f, t))
                  }),
                  this.consoleLog("Other: ShopiPay View Content Event Fired")
              }
          }, {
              key: "listenBetterCartEvents",
              value: function(t) {
                  switch (this.consoleLog("BetterCart EVENT", JSON.stringify(t)),
                  this.consoleLog("BetterCart DATA LOADED", this.shop),
                  t.type) {
                  case "Initialize":
                      this.consoleLog("BetterCart Init...");
                      break;
                  case y:
                      this.betterCartInitiateCheckoutEvent(t);
                      break;
                  case m:
                  case "PostPurchase":
                      this.betterCartPurchaseEvent(t);
                      break;
                  case f:
                      this.betterCartViewContentEvent(t);
                      break;
                  case "AddPaymentInfo":
                      this.betterCartAddpaymentinfoEvent();
                      break;
                  case v:
                      this.betterCartAddToCartEvent(t)
                  }
              }
          }, {
              key: "betterCartInitiateCheckoutEvent",
              value: function(t) {
                  // var e = this
                  //   , n = t.products.map(function(t) {
                  //     return {
                  //         id: t.id
                  //     }
                  // });
                  console.log('betterCartInitiateCheckoutEvent');
                  // this.getProductsFromBackend(n, this.cart).then(function() {
                  //     e.initiateCheckoutEvent(!0)
                  // }).catch(console.log)
              }
          }, {
              key: "betterCartPurchaseEvent",
              value: function(t) {
                  var e = [];
                  t.products.forEach(function(t) {
                      t.product_id ? e.push(t) : t.id && (t.product_id = t.id,
                      e.push(t))
                  }),
                  t.upsellStep && t.accept ? this.purchaseEvent(e, "TFX_SHP_" + t.upsellStep + " Purchase") : this.purchaseEvent(e, "TFX_SHP_Initial Purchase")
              }
          }, {
              key: "betterCartViewContentEvent",
              value: function(t) {
                  var e = !0;
                  this.isIOS14 && !this.viewContentEventFire && (this.consoleLog("IOS14: BetterCart View Content Event Restricted"),
                  e = !1);
                  var n = this;
                  t.products.forEach(function(t) {
                      return n.fire(f, e, n.getProductData(f, t))
                  }),
                  this.consoleLog("Other: BetterCart View Content Event Fired")
              }
          }, {
              key: "betterCartAddToCartEvent",
              value: function(t) {
                  this.product = t.products,
                  this.addToCartEvent()
              }
          }, {
              key: "betterCartAddpaymentinfoEvent",
              value: function() {
                  this.setCart(this.cart),
                  this.addPaymentInfoEvent()
              }
          }]) && u(e.prototype, n),
          o && u(e, o),
          t
      }();
      window.trackify || (window.trackify = new X,
      window.trackify.init())
  },
  4: function(t, e, n) {
      t.exports = n("/SWy")
  },
  ls82: function(t, e, n) {
      var o = function(t) {
          "use strict";
          var e, n = Object.prototype, o = n.hasOwnProperty, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", r = i.asyncIterator || "@@asyncIterator", c = i.toStringTag || "@@toStringTag";
          function s(t, e, n, o) {
              var i = e && e.prototype instanceof f ? e : f
                , a = Object.create(i.prototype)
                , r = new P(o || []);
              return a._invoke = function(t, e, n) {
                  var o = l;
                  return function(i, a) {
                      if (o === h)
                          throw new Error("Generator is already running");
                      if (o === p) {
                          if ("throw" === i)
                              throw a;
                          return O()
                      }
                      for (n.method = i,
                      n.arg = a; ; ) {
                          var r = n.delegate;
                          if (r) {
                              var c = b(r, n);
                              if (c) {
                                  if (c === g)
                                      continue;
                                  return c
                              }
                          }
                          if ("next" === n.method)
                              n.sent = n._sent = n.arg;
                          else if ("throw" === n.method) {
                              if (o === l)
                                  throw o = p,
                                  n.arg;
                              n.dispatchException(n.arg)
                          } else
                              "return" === n.method && n.abrupt("return", n.arg);
                          o = h;
                          var s = u(t, e, n);
                          if ("normal" === s.type) {
                              if (o = n.done ? p : d,
                              s.arg === g)
                                  continue;
                              return {
                                  value: s.arg,
                                  done: n.done
                              }
                          }
                          "throw" === s.type && (o = p,
                          n.method = "throw",
                          n.arg = s.arg)
                      }
                  }
              }(t, n, r),
              a
          }
          function u(t, e, n) {
              try {
                  return {
                      type: "normal",
                      arg: t.call(e, n)
                  }
              } catch (t) {
                  return {
                      type: "throw",
                      arg: t
                  }
              }
          }
          t.wrap = s;
          var l = "suspendedStart"
            , d = "suspendedYield"
            , h = "executing"
            , p = "completed"
            , g = {};
          function f() {}
          function v() {}
          function m() {}
          var y = {};
          y[a] = function() {
              return this
          }
          ;
          var _ = Object.getPrototypeOf
            , w = _ && _(_(L([])));
          w && w !== n && o.call(w, a) && (y = w);
          var k = m.prototype = f.prototype = Object.create(y);
          function C(t) {
              ["next", "throw", "return"].forEach(function(e) {
                  t[e] = function(t) {
                      return this._invoke(e, t)
                  }
              })
          }
          function E(t) {
              var e;
              this._invoke = function(n, i) {
                  function a() {
                      return new Promise(function(e, a) {
                          !function e(n, i, a, r) {
                              var c = u(t[n], t, i);
                              if ("throw" !== c.type) {
                                  var s = c.arg
                                    , l = s.value;
                                  return l && "object" == typeof l && o.call(l, "__await") ? Promise.resolve(l.__await).then(function(t) {
                                      e("next", t, a, r)
                                  }, function(t) {
                                      e("throw", t, a, r)
                                  }) : Promise.resolve(l).then(function(t) {
                                      s.value = t,
                                      a(s)
                                  }, function(t) {
                                      return e("throw", t, a, r)
                                  })
                              }
                              r(c.arg)
                          }(n, i, e, a)
                      }
                      )
                  }
                  return e = e ? e.then(a, a) : a()
              }
          }
          function b(t, n) {
              var o = t.iterator[n.method];
              if (o === e) {
                  if (n.delegate = null,
                  "throw" === n.method) {
                      if (t.iterator.return && (n.method = "return",
                      n.arg = e,
                      b(t, n),
                      "throw" === n.method))
                          return g;
                      n.method = "throw",
                      n.arg = new TypeError("The iterator does not provide a 'throw' method")
                  }
                  return g
              }
              var i = u(o, t.iterator, n.arg);
              if ("throw" === i.type)
                  return n.method = "throw",
                  n.arg = i.arg,
                  n.delegate = null,
                  g;
              var a = i.arg;
              return a ? a.done ? (n[t.resultName] = a.value,
              n.next = t.nextLoc,
              "return" !== n.method && (n.method = "next",
              n.arg = e),
              n.delegate = null,
              g) : a : (n.method = "throw",
              n.arg = new TypeError("iterator result is not an object"),
              n.delegate = null,
              g)
          }
          function S(t) {
              var e = {
                  tryLoc: t[0]
              };
              1 in t && (e.catchLoc = t[1]),
              2 in t && (e.finallyLoc = t[2],
              e.afterLoc = t[3]),
              this.tryEntries.push(e)
          }
          function T(t) {
              var e = t.completion || {};
              e.type = "normal",
              delete e.arg,
              t.completion = e
          }
          function P(t) {
              this.tryEntries = [{
                  tryLoc: "root"
              }],
              t.forEach(S, this),
              this.reset(!0)
          }
          function L(t) {
              if (t) {
                  var n = t[a];
                  if (n)
                      return n.call(t);
                  if ("function" == typeof t.next)
                      return t;
                  if (!isNaN(t.length)) {
                      var i = -1
                        , r = function n() {
                          for (; ++i < t.length; )
                              if (o.call(t, i))
                                  return n.value = t[i],
                                  n.done = !1,
                                  n;
                          return n.value = e,
                          n.done = !0,
                          n
                      };
                      return r.next = r
                  }
              }
              return {
                  next: O
              }
          }
          function O() {
              return {
                  value: e,
                  done: !0
              }
          }
          return v.prototype = k.constructor = m,
          m.constructor = v,
          m[c] = v.displayName = "GeneratorFunction",
          t.isGeneratorFunction = function(t) {
              var e = "function" == typeof t && t.constructor;
              return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name))
          }
          ,
          t.mark = function(t) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m,
              c in t || (t[c] = "GeneratorFunction")),
              t.prototype = Object.create(k),
              t
          }
          ,
          t.awrap = function(t) {
              return {
                  __await: t
              }
          }
          ,
          C(E.prototype),
          E.prototype[r] = function() {
              return this
          }
          ,
          t.AsyncIterator = E,
          t.async = function(e, n, o, i) {
              var a = new E(s(e, n, o, i));
              return t.isGeneratorFunction(n) ? a : a.next().then(function(t) {
                  return t.done ? t.value : a.next()
              })
          }
          ,
          C(k),
          k[c] = "Generator",
          k[a] = function() {
              return this
          }
          ,
          k.toString = function() {
              return "[object Generator]"
          }
          ,
          t.keys = function(t) {
              var e = [];
              for (var n in t)
                  e.push(n);
              return e.reverse(),
              function n() {
                  for (; e.length; ) {
                      var o = e.pop();
                      if (o in t)
                          return n.value = o,
                          n.done = !1,
                          n
                  }
                  return n.done = !0,
                  n
              }
          }
          ,
          t.values = L,
          P.prototype = {
              constructor: P,
              reset: function(t) {
                  if (this.prev = 0,
                  this.next = 0,
                  this.sent = this._sent = e,
                  this.done = !1,
                  this.delegate = null,
                  this.method = "next",
                  this.arg = e,
                  this.tryEntries.forEach(T),
                  !t)
                      for (var n in this)
                          "t" === n.charAt(0) && o.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e)
              },
              stop: function() {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ("throw" === t.type)
                      throw t.arg;
                  return this.rval
              },
              dispatchException: function(t) {
                  if (this.done)
                      throw t;
                  var n = this;
                  function i(o, i) {
                      return c.type = "throw",
                      c.arg = t,
                      n.next = o,
                      i && (n.method = "next",
                      n.arg = e),
                      !!i
                  }
                  for (var a = this.tryEntries.length - 1; a >= 0; --a) {
                      var r = this.tryEntries[a]
                        , c = r.completion;
                      if ("root" === r.tryLoc)
                          return i("end");
                      if (r.tryLoc <= this.prev) {
                          var s = o.call(r, "catchLoc")
                            , u = o.call(r, "finallyLoc");
                          if (s && u) {
                              if (this.prev < r.catchLoc)
                                  return i(r.catchLoc, !0);
                              if (this.prev < r.finallyLoc)
                                  return i(r.finallyLoc)
                          } else if (s) {
                              if (this.prev < r.catchLoc)
                                  return i(r.catchLoc, !0)
                          } else {
                              if (!u)
                                  throw new Error("try statement without catch or finally");
                              if (this.prev < r.finallyLoc)
                                  return i(r.finallyLoc)
                          }
                      }
                  }
              },
              abrupt: function(t, e) {
                  for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                      var i = this.tryEntries[n];
                      if (i.tryLoc <= this.prev && o.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                          var a = i;
                          break
                      }
                  }
                  a && ("break" === t || "continue" === t) && a.tryLoc <= e && e <= a.finallyLoc && (a = null);
                  var r = a ? a.completion : {};
                  return r.type = t,
                  r.arg = e,
                  a ? (this.method = "next",
                  this.next = a.finallyLoc,
                  g) : this.complete(r)
              },
              complete: function(t, e) {
                  if ("throw" === t.type)
                      throw t.arg;
                  return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg,
                  this.method = "return",
                  this.next = "end") : "normal" === t.type && e && (this.next = e),
                  g
              },
              finish: function(t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                      var n = this.tryEntries[e];
                      if (n.finallyLoc === t)
                          return this.complete(n.completion, n.afterLoc),
                          T(n),
                          g
                  }
              },
              catch: function(t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                      var n = this.tryEntries[e];
                      if (n.tryLoc === t) {
                          var o = n.completion;
                          if ("throw" === o.type) {
                              var i = o.arg;
                              T(n)
                          }
                          return i
                      }
                  }
                  throw new Error("illegal catch attempt")
              },
              delegateYield: function(t, n, o) {
                  return this.delegate = {
                      iterator: L(t),
                      resultName: n,
                      nextLoc: o
                  },
                  "next" === this.method && (this.arg = e),
                  g
              }
          },
          t
      }(t.exports);
      try {
          regeneratorRuntime = o
      } catch (t) {
          Function("r", "regeneratorRuntime = r")(o)
      }
  },
  o0o1: function(t, e, n) {
      t.exports = n("ls82")
  }
});
